import { CommonButton } from '../../components/buttons';
import { change, formValueSelector, reduxForm } from 'redux-form';
import {
  checkIsValidAppointment,
  createAppointment,  
  deleteAppointment,
  getAppointmentData,
  getDataForScheduler,
  getDataForSchedulerForNewAppointment,
  getMasterData,
  getPatientAuthorizationDetails,
  getPatientAuthorizationsList,
  getPatientByName,
  getPatientInsuranceById,
  getStaffsAndPatientsByLocation,
  sendAppointmentNotification,
  deleteAppointmentDataFromReoccurrence,
  deleteAppointmentBulkDataFromReoccurrence,
  checkClinicalRoomAvailablity,
  getPatientInsuranceByPatientIdAndDOS,
  checkIsValidAppointmentPatient,
  getAppointmentTypeDefaultSetting,
} from './actions/SchedulingActions_NewFeatures';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import React from 'react';
import RenderForm from './renderFormContainer_NewFeatures';
import RenderRecurrenceList from './renderRecurrenceListContainer';
import ChangeAppointmentDateDialog from './changeAppointmentDateDialog';
import SmallLoader from '../../img/small-loader.gif';
import { CBF, AIP, POPPYSPROMISE, VIP, ABCSPECTRUM, showErrorMessage, JOYSCAPE, KNOWBOUNDARIES, ADASTRA, DEMO } from '../../actions/utilAction';

const isCheckForPatientInsurance = true;
const validate = (values) => {
  const errors = {};

  // if (!values.Notes) {
  //   errors.Notes = 'Please enter appointment title';
  // }
  if (!values.SelectedLocationID || !Number.isInteger(values.SelectedLocationID)) {
    errors.SelectedLocationID = 'Please select organisation location';
  }
  if (!values.StaffIDs) {
    errors.StaffIDs = 'Please select Employee';
  } else if (values.StaffIDs.constructor === Array && !values.StaffIDs.length) {
    errors.StaffIDs = 'Please select atleast one Employee';
  }
  if (!values.AppointmentTypeID || !Number.isInteger(values.AppointmentTypeID)) {
    errors.AppointmentTypeID = 'Please select appointment type';
  }
  // if (!values.PatientAuthorizationID || !Number.isInteger(values.PatientAuthorizationID)) {
  //   errors.PatientAuthorizationID = 'Please select insurance authorization';
  // }
  // if (!values.PatientInsuranceID || !Number.isInteger(values.PatientInsuranceID)) {
  //   errors.PatientInsuranceID = 'Please select Insurance';
  // }
  if (!values.ServiceLocationID || !Number.isInteger(values.ServiceLocationID)) {
    errors.ServiceLocationID = 'Please select service location';
  }
  // if (!values.CustomAddressID || !Number.isInteger(values.CustomAddressID)) {
  //   errors.CustomAddressID = 'Please select address type';
  // }
  if (!values.CustomAddress) {
    errors.CustomAddress = 'Invalid address. Please choose address from dropdown';
  }

  if (!Number.isInteger(values.IsDirectService)) {
    errors.IsDirectService = 'Please select service type';
  }

  if (!values.SupervsieeStaffIds) {
    errors.SupervsieeStaffIds = 'Please select supervise';
  } else if (values.SupervsieeStaffIds.constructor === Array && !values.SupervsieeStaffIds.length) {
    errors.SupervsieeStaffIds = 'Please select atleast one supervise';
  }
  if (!values.ModeOfMeetingId || !Number.isInteger(values.ModeOfMeetingId)) {
    errors.ModeOfMeetingId = 'Please select mode of meeting';
  }
  if (!values.SupervisionTypeId || !Number.isInteger(values.SupervisionTypeId)) {
    errors.SupervisionTypeId = 'Please select supervision type';
  }

  if (values.DriveTime && !(/(([01][0-9]|2[0-3]):[0-5][0-9].*)$/.test(values.DriveTime))) {
    errors.DriveTime = 'Please enter drive time in HH:mm format';
  }
  // if (values.Mileage && !(/^(?:\d.\d{1,3}|\d+)$/.test(values.Mileage))) {
  //   errors.Mileage = 'Please enter valid mileage';
  // }

  let startDateTime = moment(values.startDate).format('YYYY-MM-DD') + 'T' + moment(values.startTime).format('HH:mm:ss');
  let endDateTime = moment(moment(values.endDate).format('YYYY-MM-DD') + 'T' + moment(values.endTime).format('HH:mm:ss'));
  let duration = moment.duration(endDateTime.diff(startDateTime));
  // console.log(duration.asHours());
  if (duration.asHours() > 24) {
    errors.endDate = 'Appointment schedule cannot be more than 24 hours';
  }
  if (duration.asHours() <= 0) {
    errors.endTime = 'Please enter valid appointment end time';
  }


  // validations for the recurrence rule ...
  if (!values.Every) {
    errors.Every = 'Please enter Interval';
  }
  if (!values.End || !Number.isInteger(values.End)) {
    errors.End = 'Please select end time';
  }
  if (!values.BYMONTH || !Number.isInteger(values.BYMONTH)) {
    errors.BYMONTH = 'Please select month';
  }
  if (!values.BYMONTHDAY || !Number.isInteger(values.BYMONTHDAY)) {
    errors.BYMONTHDAY = 'Please select day of month';
  }
  if (!values.BYSETPOS || !Number.isInteger(values.BYSETPOS)) {
    errors.BYSETPOS = 'Please select at';
  }
  if (!values.BYDAY) {
    errors.BYDAY = 'Please select day';
  }
  if (!values.COUNT) {
    errors.COUNT = 'Please enter count';
  }
  if (!values.UNTIL) {
    errors.UNTIL = 'Please select date';
  }
  return errors;
};


/**
 * Dialog content can be scrollable.
 */
class AppointmentDialog extends React.Component {
  constructor(props) {
    // console.log(props);
    super(props);
    this.state = {
      rule: 'DAILY',
      interval: 1,
      validations: [],
      RecurrencePattern: {},
      open: true,
      startDate: this.props.slotDetails.start,
      startTime: this.props.slotDetails.start,
      endDate: this.props.slotDetails.end,
      endTime: this.props.slotDetails.end,
      appointmentId: this.props.slotDetails.id ? this.props.slotDetails.id : null,
      appointmentStaffs: [],
      appointmentSingleStaff: [],
      appointmentSupervsieeStaffs: [],
      appointmentTypes: [],
      // staffs: props.master_data.staffs,
      allStaff: this.props.isInActive? [] : props.staffs,
      value: '',
      IsRecurrence: false,
      searched_patients: [],
      delete_clicked: false,
      schedulerPatientId: props.patient_id,
      editPatientId: this.props.slotDetails.patientID,
      userLocationList: [],
      serviceLocations: [],
      dropdownServiceLocations: [],
      isServiceAtPatientAddress: false,
      isServiceAtCustomAddress: false,
      selectedOfficeAddressId: null,
      selectedPatientAddressId: null,
      selectedCustomAddressId: null,
      latitude: 0,
      longitude: 0,
      edit_in_recurrence: false,
      RecurrenceRule: props.slotDetails.RecurrenceRule ? props.slotDetails.RecurrenceRule : null,
      appointmentTypeDuration: 0,
      allowMultipleStaff: this.props.addMultipleStaffWhenCreatingNonBillableSession ? true : false,
      isClientRequired: false,
      isRequiredAuthorization: false,
      isBillableAppointment: false,
      selectedOrganizationLocations: [],
      selectedLocationID: null,
      verifyRecurrenceAppointments: null,
      openDateDialog: false,
      recurrenceAppointmentStartTime: new Date(),
      recurrenceAppointmentEndTime: new Date(),
      changeAppointmentIndex: null,
      changeAppointmentObj: null,
      isAppointmentAuthorized: true,
      authorizationMessage: '',
      availabilityErrorMessage: '',
      insuranceErrorMessage: '' ,
      availabilityRemaininAuthMessage: '',
      IsExcludeFromMileage: false,
      IsDirectService: null,
      isValidAddress: true,
      customAddress: '',
      serviceAddress: null,
      patientInsuranceList: [],
      patientAuthorizationsList: [],
      IsExcludeFromPayroll: false,
      noteTypeId : 0,
      IsTelehealthServiceLocation: false,
      isEditRecurrence: false,
      clinicalRoomAvailablityMessage: '',
      clinicalRoomAvailablityCode: 0,
      isValidAppointmentTypeChange: true,
      isPreviousAptTypeBillable: false,
      IsClientCheckedIn: false,
      IsApptTimeEditableAfterRender: false,
      claimId: 0,
      UpdateTimeAfterRenderingTheSessionMessage: '',
      UpdateTimeAfterSubmissionTheSessionMessage: '',
      UpdateMessageAfterSubmission : '',
      IsMakeUpSession: false,
      patientInsuranceId : this.props.patientInsuranceId,
      setting_type : '',
      userModifiedFields : [],
    };
    this.handleClick = this.handleClick.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.handleRecurrenceChecked = this.handleRecurrenceChecked.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);    
    this.handleChangeStaff = this.handleChangeStaff.bind(this);
    this.handleChangeAppointmentType = this.handleChangeAppointmentType.bind(this);
    this.handleChangePatientInsurance = this.handleChangePatientInsurance.bind(this);
    this.handleChangePatientAuthorization = this.handleChangePatientAuthorization.bind(this);
    this.handleChangeOrganizationLocation = this.handleChangeOrganizationLocation.bind(this);
    this.handleRecurrenceAppointments = this.handleRecurrenceAppointments.bind(this);
    this.handleCloseDateDialog = this.handleCloseDateDialog.bind(this);
    this.checkIsValidAppointment = this.checkIsValidAppointment.bind(this);
    this.checkAuthorizationDetails = this.checkAuthorizationDetails.bind(this);
    this.GetFullAddress = this.GetFullAddress.bind(this);
    this.IsFullAddressEmpty = this.IsFullAddressEmpty.bind(this);
    this.handleChangeRoom = this.handleChangeRoom.bind(this);
    this.handleChangeSupervsieeStaff = this.handleChangeSupervsieeStaff.bind(this);
  }

  componentDidMount(){
    if(this.props.isInActive){
      this.props.dispatch(change('AppointmentDialog', 'PatientID', null));
      this.props.dispatch(change('AppointmentDialog', 'PatientName', ""));
      this.props.dispatch(change('AppointmentDialog', 'StaffIDs', null ));
    }
  }

  GetFullAddress(componentForm) {
    this.setState({
      latitude: componentForm.lat,
      longitude: componentForm.lng,
      isValidAddress: true,
    }, () => {      
      let address = (componentForm.street_number === 'short_name' && componentForm.route === 'long_name' ? '' :
      componentForm.street_number === 'short_name' ? componentForm.route : componentForm.street_number + ' ' + componentForm.route) 
          + (componentForm.locality === 'long_name' ? '' : ', ' + componentForm.locality)
          + (componentForm.administrative_area_level_1 === 'short_name' ? '' : ', ' +  componentForm.administrative_area_level_1)
          + (componentForm.country === 'short_name' ? '' : ', ' + componentForm.country)
          + (componentForm.postal_code === 'short_name' ? '' : ', ' + componentForm.postal_code);

      this.setState({ customAddress:  address });
    })
  }

  IsFullAddressEmpty(searchText) {
    if (searchText.length === 0)
      this.setState({ isValidAddress: false, customAddress: null });
    }

  componentWillMount() {
    if (this.state.appointmentId) {
      this.props.getAppointmentData(this.state.appointmentId);
    }
    if (!this.state.schedulerPatientId) {
      let OrgLocations = this.props.selectedLocations;
      let selectedSingleLocationId = null,
        selectedSingleStaffId = null,
        selectedSinglePatientId = null;
      if (this.props.selectedLocations && this.props.selectedLocations.length === 1) {
        selectedSingleLocationId = this.props.selectedLocations[0].id;
      }
      if (this.props.selectedStaffs && this.props.selectedStaffs.length === 1) {
        selectedSingleStaffId = this.props.selectedStaffs[0];
      }
      if (this.props.selectedPatients && this.props.selectedPatients.length === 1) {
        selectedSinglePatientId = this.props.selectedPatients[0];
      }
      if (!this.state.appointmentId) {
        this.getDataForScheduler(selectedSingleLocationId, selectedSinglePatientId);
        this.setState({
          selectedLocationID: selectedSingleLocationId,
        }, () => {
          this.checkIsValidAppointment(selectedSingleStaffId, selectedSinglePatientId);
        });
        let isCallFromDailog = true;
        this.props.getStaffsAndPatientsList(selectedSingleLocationId, isCallFromDailog);
        this.getPatientInsuranceList(selectedSinglePatientId);
      }
      this.setState({ selectedOrganizationLocations: OrgLocations, selectedLocationID: selectedSingleLocationId });
    } else {
      let OrgLocations = this.props.userLocationList.filter((Obj) => Obj.id === this.props.currentLocationId);
      this.setState({ selectedOrganizationLocations: OrgLocations, selectedLocationID: this.props.currentLocationId });
      if (!this.state.appointmentId) {
        this.getDataForScheduler(this.props.currentLocationId, this.state.schedulerPatientId);
        this.getPatientInsuranceList(this.state.schedulerPatientId);
        let isCallFromDailog = true;
        this.props.getStaffsAndPatientsList(this.props.currentLocationId, isCallFromDailog);
      }
    }

  }

  handleRecurrenceChecked = (input) => {
    this.setState({ IsRecurrence: input.target.checked });
  }

  handleChangeRBT = (input) => {
    this.setState({IsRBTSupervision : input.target.checked}, ()=> {
      this.setState({
        UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
      })
    })

  }

  handleChangeNotes = (event) => {
    this.setState({notes : event.target.value},() => {
      this.setState({
        UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
      })
    })
  }

  handleCheckExcludeFromMileage = (input) => {
    this.setState({ IsExcludeFromMileage: input.target.checked },()=> {
      this.setState({
        UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
      })
    });
  }

  handleCheckExcludeFromPayroll = (input) => {
    this.setState({ IsExcludeFromPayroll: input.target.checked}, () => {
      this.setState({
        UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
      })
    });
  }

  handleCheckMakeUpSession = (input) => {
    this.setState({ IsMakeUpSession: input.target.checked},()=>{
      this.setState({
        UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
    })
    });
  }

  handleCheckClientCheckedIn = (input) => {
    this.setState({ IsClientCheckedIn: input.target.checked }, ()=> {
      this.setState({
        UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
      })
    });
  }
  
  changeIsDirectService = (e, value) => {
    this.setState({
      UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
    })
    if(parseInt(value || 0, 10) === 1)
    {
      //if(this.state.IsTelehealthServiceLocation && (this.props.agencyName.toUpperCase() === AIP || this.props.agencyName.toUpperCase() === ABCSPECTRUM || this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === JOYSCAPE || this.props.agencyName.toUpperCase() === KNOWBOUNDARIES || this.props.agencyName.toUpperCase() === ADASTRA || this.props.agencyName.toUpperCase() === 'ABCABA' || this.props.agencyName.toUpperCase() === 'CLINICALB'))
      if(this.state.IsTelehealthServiceLocation)
      {
        this.setState({ IsDirectService: parseInt(value || 0, 10), IsExcludeFromMileage: true },
        ()=>{
          this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', true))
        });    
      }      
      else
      {
        this.setState({ IsDirectService: parseInt(value || 0, 10), IsExcludeFromMileage: false },
            ()=>{
              this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', false))
            });   
      }
    }
    else
    {
      if(this.props.agencyName.toUpperCase() === 'BRAINSPOTENTIAL')
      {
        this.setState({ IsDirectService: parseInt(value || 0, 10), IsExcludeFromMileage: false },
        ()=>{
          this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', false))
        });   
      }
      else{
        this.setState({ IsDirectService: parseInt(value || 0, 10), IsExcludeFromMileage: true },
        ()=>{
          this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', true))
        }); 
      }
    }
    // this.setState({ IsDirectService: parseInt(value || 0, 10) });
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  handleSendAppointmentNotification = () => {    
    this.props.sendAppointmentNotification(this.state.appointmentId);
    this.handleClose();    
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.appointment_created && this.props.appointment_created !== nextProps.appointment_created) {
      this.handleClose();
    }
    if (nextProps.verifyRecurrenceAppointments && this.props.verifyRecurrenceAppointments !== nextProps.verifyRecurrenceAppointments) {
      let appointments = nextProps.verifyRecurrenceAppointments.data;
      this.setState({ verifyRecurrenceAppointments: appointments });
    }
    if (nextProps.appointmentData && this.props.appointmentData !== nextProps.appointmentData) {
      let appointment = nextProps.appointmentData;
      this.setState({
        edit_in_recurrence: appointment.isRecurrence ? true : false,
        IsExcludeFromMileage: appointment.isExcludedFromMileage,
        IsDirectService: appointment.isDirectService ? 1 : 0,
        //allowMultipleStaff: appointment.allowMultipleStaff,
        isClientRequired: appointment.isClientRequired,
        isRequiredAuthorization: appointment.isRequiredAuthorization,
        isBillableAppointment: appointment.isBillable,
        selectedLocationID: appointment.serviceLocationID,
        appointmentStaffs: appointment.appointmentStaffs,
        appointmentSingleStaff: appointment.appointmentSingleStaff,
        appointmentSupervsieeStaffs: appointment.appointmentSupervsieeStaffs,
        selectedOfficeAddressId: appointment.officeAddressID,
        selectedPatientAddressId: appointment.patientAddressID,
        selectedCustomAddressId: appointment.customAddressID,
        isServiceAtPatientAddress: appointment.patientAddressID ? true : false,
        isServiceAtCustomAddress: appointment.customAddress ? true : false,
        customAddress: appointment.customAddress || null,
        latitude: appointment.latitude,
        longitude: appointment.longitude,
        serviceAddress: appointment.address,
        IsExcludeFromPayroll: appointment.isExcludedFromPayroll,
        noteTypeId: appointment.noteTypeId,
        RecurrenceRule : appointment.recurrenceRule,
        isPreviousAptTypeBillable: appointment.isBillable ? true : false,
        //IsRecurrence : appointment.isRecurrence ? true : false,        
        IsClientCheckedIn: appointment.isClientCheckedIn,
        BatchParentAppointmentId: appointment.batchParentAppointmentId || 0,
        IsApptTimeEditableAfterRender: (appointment.claimId > 0 && appointment.canEdit && this.props.modifyAfterRenderPermission === false) ? false : true,
        IsMakeUpSession: appointment.isMakeUpSession,
        claimId: appointment.claimId,
      });
      if (!appointment.patientID) {
        // this.props.getPatientByName({ filter: 'id', keyword: appointment.patientID, pageSize: '5' });
        // this.props.dispatch(change('AppointmentDialog', 'PatientName', 'Non-Billable'));
      }
      this.getDataForScheduler(appointment.serviceLocationID, appointment.patientID || null, appointment.patientInsuranceId || null);
      this.getPatientInsuranceList(appointment.patientID || null);
      let patientId = appointment.patientID;
      this.getPatientAuthorizationsList(appointment.patientInsuranceId, patientId);

      // this.props.dispatch(change('AppointmentDialog', 'Recurrence', appointment.isRecurrence));
      // this.props.dispatch(change('AppointmentDialog', 'CustomAddress', appointment.customAddress || null));
      // this.props.dispatch(change('AppointmentDialog', 'CustomAddressID', appointment.customAddressID || null));

      if (appointment.serviceLocationID) {
        let isCallFromDailog = true;
        this.props.getStaffsAndPatientsList(appointment.serviceLocationID, isCallFromDailog);
      }

    }

    if (nextProps.allPatients && this.props.allPatients !== nextProps.allPatients) {
      if (!this.state.value) {
        this.setState({
          searched_patients: nextProps.allPatients,
        });
        // if (this.state.editPatientId || this.state.schedulerPatientId) {
        //   let patient = nextProps.allPatients.length ? nextProps.allPatients[0] : {};
        //   this.props.dispatch(change('AppointmentDialog', 'PatientID', patient.id));
        //   this.props.dispatch(change('AppointmentDialog', 'PatientName', patient.name));
        //   this.setState({
        //     editPatientId: null,
        //     value: patient.name,
        //     searched_patients: [],
        //   });
        // }
      }
    }
    if (nextProps.staffsAndPatientsBySingleLocation && this.props.staffsAndPatientsBySingleLocation !== nextProps.staffsAndPatientsBySingleLocation) {
      // console.log("staff and patient lists --------", nextProps.staffsAndPatientsBySingleLocation);
      let allList = nextProps.staffsAndPatientsBySingleLocation.data;
      this.setState({
        // allPatient: allList.patients,
        allStaff: this.props.isInActive ? [] : allList.staff,
      });
    }
    if (nextProps.patientDetails && this.props.patientDetails !== nextProps.patientDetails) {
      // console.log("payer appointments list --------", nextProps.payerActivities);
      let allList = nextProps.patientDetails.data;
      if (allList) {
        let locations = [];
        if (allList.PatientAddresses) {
          locations = allList.PatientAddresses.map((obj) => {
            return {
              id: obj.rowNo,
              value: obj.value,
            };
          });
          // get the service address selected in update case ...
          let selectedOfficeAddressId = this.state.selectedOfficeAddressId,
            selectedPatientAddressId = this.state.selectedPatientAddressId,
            // selectedCustomAddressId = this.state.selectedCustomAddressId,
            isServiceAtCustomAddress = this.state.isServiceAtCustomAddress;
          if (selectedPatientAddressId || selectedOfficeAddressId) {
            // here find the key to know which address is choosen
            let findKey = selectedPatientAddressId ? 'patient' : selectedOfficeAddressId ? 'office' : '';
            let selectedId = selectedPatientAddressId || selectedOfficeAddressId;
            let locationObj = (allList.PatientAddresses || []).filter((address) => (address.key || '').toLowerCase() === findKey).find((obj) => (obj.id === selectedId));
            if (locationObj) {
              // this.props.dispatch(change('AppointmentDialog', 'ServiceAddress', locationObj.fullAddress || ''));
              this.props.dispatch(change('AppointmentDialog', 'ServiceLocationID', locationObj.rowNo || null));
            }
          } else if (isServiceAtCustomAddress) {
            let locationObj = (allList.PatientAddresses || []).find((obj) => ((obj.key || '').toLowerCase() === 'other'));
            if (locationObj) {
              this.props.dispatch(change('AppointmentDialog', 'ServiceLocationID', locationObj.rowNo || null));
            }            
          }
          // else { // By default service location Office
          //   let locationObj = (allList.PatientAddresses || []).find((obj) => ((obj.key || '').toLowerCase() === 'office'));
          //   if (locationObj) {
          //     this.props.dispatch(change('AppointmentDialog', 'ServiceLocationID', locationObj.rowNo || null));
          //   } 
          // }
          
          //start By dault office location is selected
          if (!this.state.appointmentId && this.props.agencyName.toUpperCase() === CBF) {
            let locationObj = (allList.PatientAddresses || []).filter((address) => (address.key || '').toLowerCase() === 'office');           
            if (locationObj) {
              locationObj = locationObj[0];      
              this.props.dispatch(change('AppointmentDialog', 'ServiceLocationID', locationObj.rowNo || null));              
              let locationAddress = locationObj.fullAddress || null;           
              this.setState({
                isServiceAtCustomAddress: false,
                isServiceAtPatientAddress: false,
                selectedPatientAddressId: null,
                selectedOfficeAddressId: locationObj.id,
                latitude: locationObj.latitude || 0,
                longitude: locationObj.longitude || 0,
                serviceAddress : locationAddress,       
              }, ()=>{this.props.dispatch(change('AppointmentDialog', 'ServiceAddress', locationAddress));});              
            }
          }
          //end By dault office location is selected
        }
        this.setState({
          appointmentTypes: allList.PatientPayerActivities,
          serviceLocations: allList.PatientAddresses,
          dropdownServiceLocations: locations,
        });

      }
    }

    if (nextProps.patientAuthorizationDetails && this.props.patientAuthorizationDetails !== nextProps.patientAuthorizationDetails) {
      // console.log('patientAuthorizationDetails --------', nextProps.patientAuthorizationDetails);
      let authorization = nextProps.patientAuthorizationDetails.data;
      let authMessage = ''
        , isValid = true;
      if (authorization && authorization.length) {
        let message = authorization[0].authorizationMessage;
        if (message.toLowerCase() === 'valid' && authorization[0].isAuthorizationMandatory === true) {
          isValid = true;
          authMessage = authorization[0].authRemainingHours;
        }
        else if (message.toLowerCase() === 'valid' && authorization[0].isAuthorizationMandatory === false) {
          isValid = true;
          authMessage = '';
        }
        else {
          isValid = false;
          authMessage = message;
        }
      }
      if(isValid)      
        this.setState({ isAppointmentAuthorized: isValid, availabilityRemaininAuthMessage: authMessage });
      else
        this.setState({ isAppointmentAuthorized: isValid, authorizationMessage: authMessage });
    }

    if (nextProps.clinicalRoomAvailablityDetails && this.props.clinicalRoomAvailablityDetails !== nextProps.clinicalRoomAvailablityDetails) {       
      let clinicalRoom = nextProps.clinicalRoomAvailablityDetails.data;
      let clinicalRoomMessage = '', code = 1;
      if (clinicalRoom && clinicalRoom.length) {        
        let isValid = clinicalRoom[0].isValid;
        if (isValid) {
          isValid = true;
          code = clinicalRoom[0].code;     
          clinicalRoomMessage = clinicalRoom[0].clinicalRoomMessage;
        }
        else {
          isValid = false;
          code = clinicalRoom[0].code;     
          clinicalRoomMessage = clinicalRoom[0].clinicalRoomMessage;
        }
      }
      this.setState({ clinicalRoomAvailablityCode: code, clinicalRoomAvailablityMessage: clinicalRoomMessage });
    }

    if (nextProps.checkValidAppointment && this.props.checkValidAppointment !== nextProps.checkValidAppointment) {    
      let message = !nextProps.checkValidAppointment.isValid ? nextProps.checkValidAppointment.errorMessage : '';     
      this.setState({ availabilityErrorMessage: message });
    }
    // if(Object.keys(nextProps.patientInsuranceList.data).length ){
    //   this.setState({ insuranceErrorMessage: '' })
    // }

    // if (nextProps.patientInsuranceList && nextProps.patientInsuranceList !== this.props.patientInsuranceList) {
    //   let patientInsuranceList = nextProps.patientInsuranceList.data || [];
    //   this.setState({ patientInsuranceList });
    //   if(patientInsuranceList.length === 1) {
    //     let [ firstValue ] = patientInsuranceList;
    //     this.setState({ allowMultipleStaff: false },()=>{
    //       this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', firstValue.id || null));
    //     });
    //     // same code in handle change patient insurance...

    //     if (!this.state.appointmentId) {
    //       this.getDataForScheduler(this.state.selectedLocationID, this.state.schedulerPatientId || this.props.selectorPatientId || null, firstValue.id);
    //       let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
    //       this.getPatientAuthorizationsList(firstValue.id, patientId);
    //       this.props.dispatch(change('AppointmentDialog', 'AppointmentTypeID', null));
    //       this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', null));
    //       this.setState({ isBillableAppointment: false, isRequiredAuthorization: false, isAppointmentAuthorized: true, authorizationMessage: '' });
    //     }
    //   }
    // }

    // if (nextProps.patientInsuranceListByDOS === null && nextProps.patientInsuranceListByDOS != this.props.patientInsuranceListByDOS && this.state.appointmentId > 0 && this.props.ownStartDate != this.state.startDate) {      
    //   this.setState({ allowMultipleStaff: false, isBillableAppointment: false, isRequiredAuthorization: false, isAppointmentAuthorized: true, authorizationMessage: '',patientInsuranceList: [],
    //   patientAuthorizationsList: [], appointmentTypes: []},()=>{
    //     this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', null));
    //     this.props.dispatch(change('AppointmentDialog', 'AppointmentTypeID', null));
    //       this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', null));
    //   });
    // }

    if (nextProps.patientAuthorizationsList && nextProps.patientAuthorizationsList !== this.props.patientAuthorizationsList) {
      let patientAuthorizationsList = nextProps.patientAuthorizationsList.data || [];
      this.setState({ patientAuthorizationsList });
      if(patientAuthorizationsList.length === 1) {
        let [ firstValue ] = patientAuthorizationsList;
        this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', firstValue.id || null));
      }
    }

    // on ESC key press close Dailog ...
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  componentDidUpdate(prevProps) {

    if (prevProps.defaultSettingType !== this.props.defaultSettingType) {

      const { defaultSettingType } = this.props;
      const settings = Array.isArray(defaultSettingType) ? defaultSettingType : [];

      const hasMakeUpSession = settings.some(item => item.setting_type === "Make-Up session");
      const hasExcludeFromPayroll = settings.some(item => item.setting_type === "Exclude from Payroll");
      const hasExcludeFromMileage = settings.some(item => item.setting_type === "Exclude from Mileage");
      const hasDirect = settings.some(item => item.setting_type === "Direct");

      this.props.dispatch(change('AppointmentDialog', 'IsMakeUpSession', hasMakeUpSession));
      this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromPayroll', hasExcludeFromPayroll));
      this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', hasExcludeFromMileage));
      this.props.dispatch(change('AppointmentDialog', 'IsDirectService', +(hasDirect)));

      // let isDirectService = this.state.isBillableAppointment && this.state.isRequiredAuthorization ? 1 : 0;
      // this.props.dispatch(change('AppointmentDialog', 'IsDirectService', isDirectService));
  }

    //changes by manish
    if(this.props.slotDetails && this.props.slotDetails !== prevProps.slotDetails){
      if(!this.props.slotDetails.isValidInsurance){
        let value = !(this.props.slotDetails && this.props.slotDetails.id)? this.props.appointmentData.patientInsuranceId: null;
        this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', null));
      }else{
        this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', this.props.appointmentData.patientInsuranceId));
      }
    }
    //end
    if (this.props.patientInsuranceList && prevProps.patientInsuranceList !== this.props.patientInsuranceList) {
      let patientInsuranceList = this.props.patientInsuranceList.data || [];
      this.setState({ patientInsuranceList });
  
      if (patientInsuranceList.length === 1) {
        let [firstValue] = patientInsuranceList;
        this.setState({ allowMultipleStaff: false }, () => {
          this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', firstValue.id || null));
        });
  
        if (!this.state.appointmentId) {
          this.getDataForScheduler(
            this.state.selectedLocationID,
            this.state.schedulerPatientId || this.props.selectorPatientId || null,
            firstValue.id
          );
          let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
          this.getPatientAuthorizationsList(firstValue.id, patientId);
          this.props.dispatch(change('AppointmentDialog', 'AppointmentTypeID', null));
          this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', null));
          this.setState({
            isBillableAppointment: false,
            isRequiredAuthorization: false,
            isAppointmentAuthorized: true,
            authorizationMessage: ''
          });
        }
      }
  
      if (Object.keys(this.props.patientInsuranceList.data).length === 0) {
        this.setState({ insuranceErrorMessage: 'Insurance has been expired' });
        this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', null));
        this.props.dispatch(change('AppointmentDialog', 'AppointmentTypeID', null));
      } else if (Object.keys(this.props.patientInsuranceList.data).length >= 1) {
        // Check if any insurance matches the current patientInsuranceId
        this.setState({ insuranceErrorMessage: '' },()=>{
          let insuranceFound = patientInsuranceList.some(data => data.patientInsuranceId === this.state.patientInsuranceId);
           
          if (insuranceFound || !this.state.appointmentId) {
            this.setState({ insuranceErrorMessage: '' });
          } else {
            this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', null));
            this.setState({ insuranceErrorMessage:'Insurance has been expired.Please select another insurance'});
          }
        });
      }
      // if (Object.keys(this.props.patientInsuranceList.data).length === 0) {
      //   this.setState({ insuranceErrorMessage: 'Insurance has been expired' });
      // } else if (Object.keys(this.props.patientInsuranceList.data).length > 1) {
      //   this.setState({ insuranceErrorMessage: '' },()=);
      //   // Check if any insurance matches the current patientInsuranceId
      //   let insuranceFound = patientInsuranceList.some(data => data.patientInsuranceId === this.state.patientInsuranceId);
         
      //   if (insuranceFound || !this.state.appointmentId) {
      //     this.setState({ insuranceErrorMessage: '' });
      //   } else {
      //     this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', null));
      //     this.setState({ insuranceErrorMessage:'Insurance has been expired.Please select another insurance'});
      //   }
      // }
    }
  }

  handleUserChange = (fieldName, value) => {
    this.setState(prevState => ({
      userModifiedFields: [...new Set([...(prevState.userModifiedFields || []), fieldName])]
    }));
    this.props.dispatch(change('AppointmentDialog', fieldName, value));
  };
  
  checkIsSameOrBefore = (date1, date2) => {
    return moment(date1).isSameOrBefore(date2);  
  }

  calculateLocalTimeZone() {
    let TZ = /\((.*)\)/.exec(new Date().toString());
    let TimeZone = '';
    if (TZ.length > 0)
      TimeZone = TZ[1];

    // console.log(TimeZone);
    return TimeZone;
  }

  onSingleSubmitHandler(formProps) {
    this.setState({verifyRecurrenceAppointments : null}, ()=>{
      if(this.state.isBillableAppointment)
        this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'NO');
      else
        this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'YES');
    });
  }

  onSingleSubmitTodaysSessionForIndividualStaffHandler(formProps) {    
    this.setState({verifyRecurrenceAppointments : null}, ()=>{
      if(!this.state.isBillableAppointment)        
        this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'NO');
      else 
        this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'NO');
    });
  }

  onSingleSubmitHandler(formProps) {
    this.setState({verifyRecurrenceAppointments : null}, ()=>{
      this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'NO');
    });
  }

  onSingleSubmitBulkHandler(formProps) {
    this.setState({verifyRecurrenceAppointments : null}, ()=>{
      this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'YES');
    });
  }
  

  onSubmitHandler(formProps) {
    if(this.state.isBillableAppointment) {
      this.handleSubmitClick(formProps, false, this.state.edit_in_recurrence, 'NO');
    }
    else {
      // console.log('submit this.state.appointmentStaffs..................',this.state.appointmentStaffs)
      if(formProps.StaffIDs && formProps.StaffIDs.length > 1) {    
        this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'YES');
       }
       else {
        if(this.state.appointmentStaffs && this.state.appointmentStaffs.length > 1)
          this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'YES');
        else if(this.state.appointmentStaffs && this.state.appointmentStaffs.length === 1)
          this.handleSubmitClick(formProps, false, !this.state.edit_in_recurrence, 'YES');      
        else 
          this.handleSubmitClick(formProps, true, !this.state.edit_in_recurrence, 'NO');
       }      
    }   
  }

  onSubmitServiesForIndividualStaffHandler(formProps) {      
    this.handleSubmitClick(formProps, false, this.state.edit_in_recurrence, 'NO');
  }

  onSubmitBulkHandler(formProps) {    
    this.handleSubmitClick(formProps, false, this.state.edit_in_recurrence, 'YES');
  }

  handleSubmitClick = (formProps, isSingleSubmit, edit_in_recurrence, isBulkSubmit = 'YES') => {
    if (!this.state.isAppointmentAuthorized || this.state.availabilityErrorMessage) {
      return false;
    }
    if (this.state.clinicalRoomAvailablityCode === 2) {
      return false;
    }
    if (this.state.rule.toLowerCase() === 'weekly' && !this.state.validations.length && !this.state.edit_in_recurrence) {
      return false;
    }
    if (this.state.IsRecurrence || edit_in_recurrence) {
      let recurrence = '';
      switch (this.state.rule) {
      case 'HOURLY':
        recurrence = `FREQ=${this.state.rule};INTERVAL=${formProps.Every}`;
        break;
      case 'DAILY':
        recurrence = `FREQ=${this.state.rule};INTERVAL=${formProps.Every}`;
        break;
      case 'WEEKLY':
        recurrence = `FREQ=${this.state.rule};INTERVAL=${formProps.Every};BYDAY=${this.state.validations}`;
        break;
      case 'MONTHLY':
        !formProps.byMonth || formProps.byMonth === 'onDay' ?
          recurrence = `FREQ=${this.state.rule};INTERVAL=${formProps.Every};BYMONTHDAY=${formProps.BYMONTHDAY}`
          :
          recurrence = `FREQ=${this.state.rule};INTERVAL=${formProps.Every};BYSETPOS=${formProps.BYSETPOS};BYDAY=${formProps.BYDAY}`;
        break;
      case 'YEARLY':
        !formProps.byYear || formProps.byYear === 'onDay' ?
          recurrence = `FREQ=${this.state.rule};BYMONTH=${formProps.BYMONTH};BYMONTHDAY=${formProps.BYMONTHDAY}`
          :
          recurrence = `FREQ=${this.state.rule};BYSETPOS=${formProps.BYSETPOS};BYDAY=${formProps.BYDAY};BYMONTH=${formProps.BYMONTH}`;
        break;
      default:
        break;
      }
      if (formProps.End === 1) {
        recurrence = `${recurrence};COUNT=${formProps.COUNT}`;
      } else if (formProps.End === 2) {
        let until = `${moment(formProps.UNTIL).format('YYYYMMDD')}T235959Z`; // appended the until time to get the till appointments ...
        recurrence = `${recurrence};UNTIL=${until}`;
      }
      if (recurrence.includes('undefined')) {
        formProps.RecurrenceRule = this.state.RecurrenceRule;
        //return false;
      }       
      else
        formProps.RecurrenceRule = recurrence;

      //console.log('hello......',formProps.RecurrenceRule, this.state.RecurrenceRule) 
    }
    if (this.state.isClientRequired && !this.state.schedulerPatientId) {
      if (!formProps.PatientID) {
        this.props.dispatch(change('AppointmentDialog', 'PatientName', null));
        // this.setState({ patientid_error: 'Please enter Client details' });
        return false;
      }
    }

    formProps.isClientRequired = this.state.isClientRequired;
    formProps.StartDateTime = moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm')+':00';
    formProps.EndDateTime = moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.endTime).format('HH:mm')+':00';
    formProps.RecurrenceRule = formProps.RecurrenceRule;

    if (this.state.isServiceAtCustomAddress) {
      if (this.state.customAddress === null || this.state.customAddress === '') {
        this.setState({ isValidAddress: false });
        return null;
      }
      formProps.CustomAddressID = formProps.CustomAddressID;
      // formProps.CustomAddress = formProps.CustomAddress;
      formProps.CustomAddress = this.state.customAddress; //document.getElementById('CustomAddress').value;
      formProps.PatientAddressID = null;
      formProps.OfficeAddressID = null;
    } else {
      formProps.CustomAddressID = null;
      formProps.CustomAddress = null;
      if (this.state.isServiceAtPatientAddress) {
        formProps.PatientAddressID = this.state.selectedPatientAddressId;
        formProps.OfficeAddressID = null;
      } else {
        formProps.OfficeAddressID = this.state.selectedOfficeAddressId;
        formProps.PatientAddressID = null;
      }
    }

    let appointmentStaffs =[], appointmentSingleStaff = [];
    if(isBulkSubmit === 'NO' && this.state.appointmentId !== undefined && this.state.appointmentId > 0) {
    if(!formProps.PatientID) {
      let staffIds = this.props.singleStaffId; 
        appointmentSingleStaff = this.state.appointmentSingleStaff.map((Obj) => {
          return { StaffId: Obj.staffId, IsDeleted: true };
        });
        staffIds.forEach((staffId) => {
          // update case for appointment staffs ------
          let staff = appointmentSingleStaff.find((Obj) => Obj.StaffId === staffId && Obj.IsDeleted);
          if (staff) {
            let index = appointmentSingleStaff.indexOf(staff);
            appointmentSingleStaff[index] = { StaffId: staff.StaffId, IsDeleted: false };
          } else {
            appointmentSingleStaff.push({ StaffId: staffId, IsDeleted: false });
          }
        });  
      }
      else {
        let staffIds = [formProps.StaffIDs];
        //console.log('this.props.singleStaffId............',this.props.singleStaffId)
        //let staffIds = this.props.singleStaffId; 
          appointmentSingleStaff = this.state.appointmentSingleStaff.map((Obj) => {
            return { StaffId: Obj.staffId, IsDeleted: true };
          });
          staffIds.forEach((staffId) => {
            // update case for appointment staffs ------
            let staff = appointmentSingleStaff.find((Obj) => Obj.StaffId === staffId && Obj.IsDeleted);
            if (staff) {
              let index = appointmentSingleStaff.indexOf(staff);
              appointmentSingleStaff[index] = { StaffId: staff.StaffId, IsDeleted: false };
            } else {
              appointmentSingleStaff.push({ StaffId: staffId, IsDeleted: false });
            }
          });  
      }
    }
    else {
      //let flag = false;
      let staffIds = this.state.allowMultipleStaff 
      ? Array.isArray(formProps.StaffIDs) ? formProps.StaffIDs : [formProps.StaffIDs]
      : [formProps.StaffIDs];        
      appointmentStaffs = this.state.appointmentStaffs.map((Obj) => {
          return { StaffId: Obj.staffId, IsDeleted: true };
        });

      staffIds && staffIds.forEach((staffId) => {
          // update case for appointment staffs ------
          let staff = appointmentStaffs.find((Obj) => Obj.StaffId === staffId && Obj.IsDeleted);
          if (staff) {
            let index = appointmentStaffs.indexOf(staff);
            appointmentStaffs[index] = { StaffId: staff.StaffId, IsDeleted: false };
          } else {
            appointmentStaffs.push({ StaffId: staffId, IsDeleted: false });
          }
        });
    }

    let appointmentSupervsieeStaffs = [];    
    if(formProps.SupervsieeStaffIds) {
      let supervsieeStaffIds = formProps.SupervsieeStaffIds;
      appointmentSupervsieeStaffs = this.state.appointmentSupervsieeStaffs.map((Obj) => {
        return { SupervsieeStaffId: Obj.supervsieeStaffId, IsDeleted: true };
      });
      supervsieeStaffIds.forEach((supervsieeStaffId) => {
        // update case for appointment staffs ------
        let staff = appointmentSupervsieeStaffs.find((Obj) => Obj.SupervsieeStaffId === supervsieeStaffId && Obj.IsDeleted);
        if (staff) {
          let index = appointmentSupervsieeStaffs.indexOf(staff);
          appointmentSupervsieeStaffs[index] = { SupervsieeStaffId: staff.SupervsieeStaffId, IsDeleted: false };
        } else {
          appointmentSupervsieeStaffs.push({ SupervsieeStaffId: supervsieeStaffId, IsDeleted: false });
        }
      });
    }
    
    let RBTDetails = {
      IsRBTTracking: formProps.IsRBTTracking || false,
      //SupervsieeStaffId: null,
      ModeOfMeetingId: null,
      SupervisionTypeId: null,
      IsObservedWithclient: false,
    };
    if (this.props.selectorIsRBTTracking) {
      RBTDetails = {
        ...RBTDetails,
        //SupervsieeStaffId: formProps.SupervsieeStaffId,
        ModeOfMeetingId: formProps.ModeOfMeetingId,
        SupervisionTypeId: formProps.SupervisionTypeId,
        IsObservedWithclient: formProps.IsObservedWithclient || false,
      }
    }

    let appointmentData = [{
      'PatientAppointmentId': this.state.appointmentId ? this.state.appointmentId : 0,
      'AppointmentTypeID': formProps.AppointmentTypeID,
      'AppointmentStaffs': (isBulkSubmit === 'NO' && this.state.appointmentId !== undefined && this.state.appointmentId > 0) ? appointmentSingleStaff : appointmentStaffs,
      'AppointmentSupervsieeStaffs': appointmentSupervsieeStaffs,
      'PatientID': this.state.schedulerPatientId ? this.state.schedulerPatientId : formProps.PatientID,
      'ServiceID': formProps.ServiceID,
      'ServiceLocationID': this.state.selectedLocationID,
      'OfficeAddressID': formProps.OfficeAddressID,
      'PatientAddressID': formProps.PatientAddressID,
      'CustomAddressID': (this.state.isServiceAtCustomAddress && this.props.showAddressTypeDuringAppointmentCreation ? formProps.CustomAddressID : 8),
      'CustomAddress': formProps.CustomAddress,
      'latitude': this.state.latitude || 0,
      'longitude': this.state.longitude || 0,
      'StartDateTime': formProps.StartDateTime,
      'EndDateTime': formProps.EndDateTime,
      'Notes': formProps.Notes,
      'IsTelehealthAppointment': formProps.IsTelehealthAppointment ? true : false,
      'IsRecurrence': formProps.Recurrence ? true : false,
      'RecurrenceRule': formProps.RecurrenceRule ? formProps.RecurrenceRule : (this.state.RecurrenceRule || ''),
      'IsClientRequired': this.state.isClientRequired,      
      'IsBillableAppointment': this.state.isBillableAppointment,
      'IsBillable': this.state.isBillableAppointment,
      'Offset': moment().utcOffset(),
      'Timezone': this.calculateLocalTimeZone(),
      'IsExcludedFromMileage': this.state.IsExcludeFromMileage,
      'IsDirectService': +(this.state.IsDirectService ? true : false),
      'Mileage': !this.state.IsExcludeFromMileage ? formProps.Mileage : null,
      'DriveTime': formProps.DriveTime && !this.state.IsExcludeFromMileage ? moment(formProps.DriveTime, 'h:mm a').format('HH:mm:ss') : null,
      'PatientEncounterId': this.props.appointmentData && this.props.appointmentData.patientEncounterId,
      'patientInsuranceId': formProps.PatientInsuranceID || null,
      'authorizationId': this.state.isBillableAppointment || this.state.isRequiredAuthorization ? formProps.PatientAuthorizationID : null,
      'serviceAddress': formProps.CustomAddressID ? null : this.state.serviceAddress,
      'IsExcludedFromPayroll': formProps.IsExcludedFromPayroll,
      'noteTypeId': this.state.noteTypeId,      
      'PayRateTypeId': formProps.PayRateTypeId ? formProps.PayRateTypeId : null,
      'ClinicalRoomId': formProps.ClinicalRoomId ? formProps.ClinicalRoomId : null,
      'IsClientCheckedIn': this.state.IsClientCheckedIn,
      'IsMakeUpSession': formProps.IsMakeUpSession,
      'MakeUpSessionHours':this.state.IsMakeUpSession ? formProps.MakeUpSessionHours : null,
      'BatchParentAppointmentId': this.props.batchParentAppointmentId || 0,
      // 'ChangedAfterBilling': this.state.claimId !== null && this.state.claimId > 0 ? true : false,
      ...RBTDetails
    }];
    // console.log(JSON.stringify(appointmentData));
    // here is code separated for the appointment save from patient portal ...
    if (this.props.isRequestFromPatientPortal) {
      appointmentData = appointmentData[0];
      this.props.createAppointmentFromPatientPortal(appointmentData);
      this.handleClose();
      return false;
    }
    if (appointmentData[0].PatientAppointmentId > 0) {    
      let IsFinish = true;
      let isAdminUpdate = (this.props.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission) ? true : (this.props.isUpdateAfterClaimSubmitted ? true: false);
      let isMileageUpdatedByStaff = !this.props.editAppointmentAfterClaimSubmission;

      if(isAdminUpdate && this.props.lock_scheduler != null &&  this.checkIsSameOrBefore(moment(appointmentData[0].StartDateTime).format('MM-DD-YYYY'), moment(this.props.lock_scheduler).format('MM-DD-YYYY')))
      {
        this.handleClose();
        showErrorMessage('Your schedule has been locked until ' + moment(this.props.lock_scheduler).format('MM-DD-YYYY') + ' . You are unable to schedule appointments on or before this date. Please contact your scheduler.');
      }
      else if(!this.state.isValidAppointmentTypeChange && this.props.agencyName.toUpperCase() !== CBF)
      {
        this.handleClose();
        if(this.state.isPreviousAptTypeBillable)
        {
          showErrorMessage('Unable to change to a non-billable appointment. Please delete and create a new appointment.');
        }
        else
        {
          showErrorMessage('Unable to change to a billable appointment. Please delete and create a new appointment');
        }
      }
      else
      {
        if(appointmentData[0].IsRecurrence)
        { 
          if(isSingleSubmit)
          {
            this.setState({ isEditRecurrence: false });
              this.handleClose(); 
              let IsFinish = true;
              let isAdminUpdate = (this.props.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission) ? true : (this.props.isUpdateAfterClaimSubmitted ? true: false);
              let isMileageUpdatedByStaff = !this.props.editAppointmentAfterClaimSubmission;
              this.props.createAppointment(appointmentData, IsFinish, this.props.agencyName.toUpperCase(), isAdminUpdate, isMileageUpdatedByStaff);              
          }
          else
          {
              //this.handleClose(); 
              this.setState({ isEditRecurrence: true },()=>{
                let BatchParentAppointmentId = 0;
                if(isBulkSubmit === 'NO'){
                    BatchParentAppointmentId = appointmentData[0].BatchParentAppointmentId;
                    appointmentData[0].BatchParentAppointmentId = 0;
                }
                if(appointmentData[0].BatchParentAppointmentId > 0){
                  this.props.deleteAppointmentBulkDataFromReoccurrence(appointmentData, null, true, this.props.agencyName.toUpperCase(), false, BatchParentAppointmentId, false);
                }
                else {
                  appointmentData[0].BatchParentAppointmentId = 0;
                  this.props.deleteAppointmentDataFromReoccurrence(appointmentData, null, true, this.props.agencyName.toUpperCase(), false, BatchParentAppointmentId, false);
                }
              });
              // let IsFinish = false;
              // appointmentData[0].PatientAppointmentId = 0;
              // this.props.createAppointment(appointmentData, IsFinish, this.props.agencyName.toUpperCase());      
          }
        }
        else
        { 
          if(appointmentData[0].IsBillable)
          {
            this.setState({ isEditRecurrence: false });
            this.handleClose();
            this.props.createAppointment(appointmentData, IsFinish, this.props.agencyName.toUpperCase(), isAdminUpdate, isMileageUpdatedByStaff);    
          }
          else if(isSingleSubmit)
          {            
            // console.log('single submit')
            this.setState({ isEditRecurrence: false });
              this.handleClose(); 
              
              let IsFinish = true;
              let isAdminUpdate = (this.props.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission) ? true : (this.props.isUpdateAfterClaimSubmitted ? true: false);

              let isMileageUpdatedByStaff = !this.props.editAppointmentAfterClaimSubmission;
              this.props.createAppointment(appointmentData, IsFinish, this.props.agencyName.toUpperCase(), isAdminUpdate, isMileageUpdatedByStaff);              
          }
          else{
            this.setState({ isEditRecurrence: false },()=>{
              let BatchParentAppointmentId = 0;
              BatchParentAppointmentId = appointmentData[0].BatchParentAppointmentId;
              this.props.deleteAppointmentBulkDataFromReoccurrence(appointmentData, null, true, this.props.agencyName.toUpperCase(), false, BatchParentAppointmentId, true);             
             
            });
         }                        
        }
      }
    } else {      
      this.setState({ isEditRecurrence: false });
      let IsFinish = (this.props.isRecurrence || formProps.RecurrenceRule) ? false : true;
      this.props.createAppointment(appointmentData, IsFinish, this.props.agencyName.toUpperCase());
    }
  }

  onRecurrenceSubmit() {
    let IsFinish = true;
    // console.log('this.state.verifyRecurrenceAppointments...', JSON.stringify(this.state.verifyRecurrenceAppointments))
    this.props.createAppointment(this.state.verifyRecurrenceAppointments, IsFinish, this.props.agencyName.toUpperCase());
    this.handleClose();
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({
      [input.name]: value,
      UpdateTimeAfterRenderingTheSessionMessage: this.props.isAdminUpdateAfterRendered ? 'This session has already been rendered. Modifying the Details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
      UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
    }, () => {

      // on appointment date time change get data for scheduler ...
      if (this.state.selectedLocationID) {
        this.getDataForScheduler(this.state.selectedLocationID, this.state.schedulerPatientId || this.props.selectorPatientId || null, this.props.selectorPatientInsuranceId);
      }
      // on appointment date time change check the staff availability ...
      let startDateTime = moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm:ss');
      let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
      if (this.props.selectorStaffIds || (patientId && this.props.selectorAppointmentTypeId)) {

        if(!this.state.isBillableAppointment && this.props.isAdminUpdateAfterRendered && this.state.appointmentId && this.state.appointmentId > 0) {
          this.checkIsValidAppointment(this.props.singleStaffId, patientId, this.props.selectorAppointmentTypeId);
          //this.props.getPatientInsuranceById(patientId, 'PRIMARY', (this.state.appointmentId ? true : false),startDateTime)
        } else {
          this.checkIsValidAppointment(this.props.selectorStaffIds, patientId, this.props.selectorAppointmentTypeId);
          //this.props.getPatientInsuranceById(patientId, 'PRIMARY', (this.state.appointmentId ? true : false),startDateTime)
        }
        this.getPatientInsuranceList(patientId)
       // this.props.getPatientInsuranceByPatientIdAndDOS(patientId, 'PRIMARY', (this.state.appointmentId ? true : false),startDateTime)
      }
      // on appointment date time change check the client authorization ...
      if (this.props.selectorAppointmentTypeId) {
        this.checkAuthorizationDetails(this.props.selectorAppointmentTypeId, this.props.selectorPatientInsuranceId, this.props.selectorPatientAuthorizationId);
      }
      // on appointment date time change get authorizations list ...
      if (this.state.isBillableAppointment || this.state.isRequiredAuthorization) {
        let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
        this.getPatientAuthorizationsList(this.props.selectorPatientInsuranceId, patientId);
      }
      // on appointment date time change check the Therapy room ...
      if(this.props.selectorClinicalRoomId) {
        this.checkClinicalRoomAvailablity(this.props.selectorClinicalRoomId);
      }
    });

    if (input.name === 'startDate') {
      this.setState({ endDate: value });
      this.props.dispatch(change('AppointmentDialog', 'endDate', moment(value).format()));
    }

  }

  handleClick(e, patient) {
    this.props.dispatch(change('AppointmentDialog', 'PatientID', patient.id));
    this.props.dispatch(change('AppointmentDialog', 'PatientName', patient.name));
    // this.props.dispatch(change('AppointmentDialog', 'ServiceID', null));
    this.setState(() => {
      return {
        value: patient.name,
        unitedStates: [], searched_patients: [],
        selectedPatientAddressId: null,
        isAppointmentAuthorized: true,
        authorizationMessage: '',
      };
    });
    this.getDataForScheduler(this.state.selectedLocationID, patient.id);
    this.getPatientInsuranceList(patient.id);
  }

  handleLocationChange(input, selectedValue) {
    input.onChange(selectedValue.value);
    let locationAddress = null;
    if (this.state.serviceLocations && selectedValue.value) {
      let locationObj = this.state.serviceLocations.find((obj) => obj.rowNo === selectedValue.value);
      if (locationObj) {
        locationAddress = locationObj.fullAddress || null;
        let isServiceAtCustomAddress = (locationObj.key || '').toLowerCase() === 'other',
          isServiceAtPatientAddress = (locationObj.key || '').toLowerCase() === 'patient',
          isServiceAtOfficeAddress = (locationObj.key || '').toLowerCase() === 'office';
          // console.log('locationObj.latitude.........',locationObj.latitude,locationObj.longitude);
        this.setState({
          isServiceAtCustomAddress,
          isServiceAtPatientAddress,
          selectedPatientAddressId: isServiceAtPatientAddress ? locationObj.id : null,
          selectedOfficeAddressId: isServiceAtOfficeAddress ? locationObj.id : null,
          latitude: locationObj.latitude || 0,
          longitude: locationObj.longitude || 0,
          UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
        });

        // if(this.props.agencyName.toUpperCase() === AIP || this.props.agencyName.toUpperCase() === ABCSPECTRUM || this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === JOYSCAPE || this.props.agencyName.toUpperCase() === KNOWBOUNDARIES || this.props.agencyName.toUpperCase() === ADASTRA || this.props.agencyName.toUpperCase() === 'ABCABA' || this.props.agencyName.toUpperCase() === 'CLINICALB')
        // {          
          if(selectedValue.label.toUpperCase().toString().indexOf('TELEHEALTH') !== -1){
            this.setState({ IsExcludeFromMileage: true, IsTelehealthServiceLocation: true },
            ()=>{
              this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', true))
            }); 
          }
          else
          {
            this.setState({ IsExcludeFromMileage: false, IsTelehealthServiceLocation: false },
            ()=>{
              this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', false))
            });     
          }
        // }

        // if(this.props.agencyName.toUpperCase() === JOYSCAPE && isServiceAtOfficeAddress)
        // {
        //   if(this.state.IsDirectService > 0) {
        //     this.setState({ IsExcludeFromMileage: false },
        //       ()=>{
        //         this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', false))
        //       });          
        //   }
        //   else {
        //     this.setState({ IsExcludeFromMileage: true },
        //       ()=>{
        //         this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', true))
        //       });          
        //   }
          
        // }

        if (!this.state.isBillableAppointment || !this.state.isRequiredAuthorization) {        
          this.setState({ IsDirectService: 0, IsExcludeFromMileage: true },
          ()=>{
            this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', true))
          }); 
        }
        
      }      
    }
    // else
    // {
    //   this.setState({ IsExcludeFromMileage: false },
    //     ()=>{
    //       this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', false))
    //     });          
    // }    
    this.setState({serviceAddress : locationAddress}, ()=>{this.props.dispatch(change('AppointmentDialog', 'ServiceAddress', locationAddress));});    
  }

  changeAppointmentStartTime = (time, duration) => {
    let startTime = moment(time).subtract(duration, 'minutes');
    this.props.dispatch(change('AppointmentDialog', 'startTime', startTime));
    this.setState({ startTime: startTime });
  }
  changeAppointmentEndTime = (time, duration) => {
    let endTime = moment(time).add(duration, 'minutes');
    this.props.dispatch(change('AppointmentDialog', 'endTime', endTime));
    this.setState({ endTime: endTime });
  }

  handleChangeAppointmentType(input, selectedValue) {
    input.onChange(selectedValue.value);
    //  change end time based on the appointment type selected ...   
    let selectedObject = (this.state.appointmentTypes || []).find((Obj) => Obj.id === selectedValue.value);
    let isBillable = selectedObject && selectedObject.isBillable ? true : false;
    // let allowMultipleStaff = selectedObject && selectedObject.allowMultipleStaff ? true : false;
    let isClientRequired = selectedObject && selectedObject.isClientRequired ? true : false;
    let isRequiredAuthorization = selectedObject && selectedObject.isRequiredAuthorization ? true : false;    
    // let duration = selectedObject && selectedObject.defaultDuration ? selectedObject.defaultDuration : 5;
   
    if(this.state.isPreviousAptTypeBillable === isBillable)
    {
      this.setState({isValidAppointmentTypeChange: true});
    }
    else
    {
      this.setState({isValidAppointmentTypeChange: false});
    }

    this.setState({
      isBillableAppointment: isBillable,
      // appointmentTypeDuration: duration,
      // allowMultipleStaff: allowMultipleStaff,
      isClientRequired: isClientRequired,
      isRequiredAuthorization: isRequiredAuthorization,
      UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
    }, () => {
      if (!this.state.isBillableAppointment && !this.state.isRequiredAuthorization) {
        this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', null));
      } else {
        // default selected and same handleChangePatientAuthorization ...
        let patientAuthorizationsList = this.state.patientAuthorizationsList || [];
        if(patientAuthorizationsList.length === 1 && isRequiredAuthorization ) {
          let [ firstValue ] = patientAuthorizationsList;
          this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', firstValue.id || null));
          if (selectedValue.value) {
            this.checkAuthorizationDetails(this.props.selectorAppointmentTypeId, this.props.selectorPatientInsuranceId, firstValue.id);
          }
        }
      }
      // if (!this.state.isBillableAppointment || !this.state.isRequiredAuthorization) {        
      //   this.props.dispatch(change('AppointmentDialog', 'IsDirectService', 0));
      //   this.props.dispatch(change('AppointmentDialog', 'IsDirectService', this.changeIsDirectService(0)));
      // }
    });
    // console.log('duration addition ..', duration, selectedObject);
    // this.changeAppointmentEndTime(this.state.startTime, duration);
    let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
    this.checkIsValidAppointment(this.props.selectorStaffIds, patientId, selectedValue.value);
    this.checkAuthorizationDetails(selectedValue.value, this.props.selectorPatientInsuranceId, this.props.selectorPatientAuthorizationId);
    this.props.getAppointmentTypeDefaultSetting(selectedValue.value);
  }

  handleChangePatientInsurance(input, selected) {
    input.onChange(selected.value);
    if(selected.value > 0)
    {
      let filteredPatientInsurance = (this.state.patientInsuranceList || []).find((x) => x.id === selected.value);            
      this.setState({ allowMultipleStaff: false ,insuranceErrorMessage:'', 
        UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
        UpdateMessageAfterSubmission: this.props.isUpdateAfterClaimSubmitted ? 'Please resubmit this claim to the updated payer as the original claim.' : '',          }); 
      this.props.dispatch(change('AppointmentDialog', 'Notes', filteredPatientInsurance.insuranceNotes || null));
    } 
    else {
      this.setState({ allowMultipleStaff: true }); 
    }
    this.getDataForScheduler(this.state.selectedLocationID, this.state.schedulerPatientId || this.props.selectorPatientId || null, selected.value);
    let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
    this.getPatientAuthorizationsList(selected.value, patientId);
    this.props.dispatch(change('AppointmentDialog', 'AppointmentTypeID', null));
    this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', null));
    this.setState({ isBillableAppointment: false, isRequiredAuthorization: false, isAppointmentAuthorized: true, authorizationMessage: '' });
  }

  handleChangePatientAuthorization(input, selected) {
    input.onChange(selected.value);
    this.setState({
      UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
    })
    if (this.props.selectorAppointmentTypeId) {
      this.checkAuthorizationDetails(this.props.selectorAppointmentTypeId, this.props.selectorPatientInsuranceId, selected.value);
    }
  }

  handleChangeStaff = (input, selectedValue) => {
    let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
    if (this.state.allowMultipleStaff && this.props.addMultipleStaffWhenCreatingNonBillableSession && (patientId === undefined || patientId === null || patientId <= 0)) {
    //if (this.state.allowMultipleStaff && this.props.addMultipleStaffWhenCreatingNonBillableSession) {
      input.onChange(selectedValue);
      this.checkIsValidAppointment(selectedValue.join(','), patientId, this.props.selectorAppointmentTypeId);
    } else {
      input.onChange(selectedValue.value);
      this.checkIsValidAppointment(selectedValue.value, patientId, this.props.selectorAppointmentTypeId);
    }
  };

  handleChangeSupervsieeStaff = (input, selectedValue) => {    
    input.onChange(selectedValue);      
  };  

  handleChangeRoom = (input, selectedValue) => {    
    input.onChange(selectedValue.value);
    this.setState({
      UpdateTimeAfterSubmissionTheSessionMessage: this.props.isUpdateAfterClaimSubmitted ? 'Warning: This session has already been billed. Modifying the details will also change the units. Please ensure you have this session re-signed by the staff and/or guardian.' : '',
    })
    if(selectedValue.value)
      this.checkClinicalRoomAvailablity(selectedValue.value);
  };

  handleChangeOrganizationLocation(input, selectedValue) {
    input.onChange(selectedValue.value);
    this.setState({ selectedLocationID: selectedValue.value });
    
    //Resting start
    this.setState({
      isBillableAppointment: false, isRequiredAuthorization: false, isAppointmentAuthorized: true, authorizationMessage: '',
      value: '', searched_patients: [],
      isServiceAtCustomAddress : false,
      isServiceAtPatientAddress : false,
      selectedPatientAddressId: null,
      selectedOfficeAddressId: null,
      latitude: 0,
      longitude: 0,
      authorizationMessage: '',
      availabilityRemaininAuthMessage: '',
      clinicalRoomAvailablityMessage: '',
      UpdateTimeAfterRenderingTheSessionMessage: '',
      UpdateTimeAfterSubmissionTheSessionMessage: '',
    },()=>{
      this.getDataForScheduler(this.state.selectedLocationID, null);
      this.props.dispatch(change('AppointmentDialog', 'PatientID', null));
      this.props.dispatch(change('AppointmentDialog', 'PatientName', null));      
      this.props.dispatch(change('AppointmentDialog', 'PatientInsuranceID', null));      
      this.props.dispatch(change('AppointmentDialog', 'AppointmentTypeID', null));
      this.props.dispatch(change('AppointmentDialog', 'PatientAuthorizationID', null));
      this.props.dispatch(change('AppointmentDialog', 'StaffIDs', null));
      this.props.dispatch(change('AppointmentDialog', 'ServiceLocationID', null));
      this.props.dispatch(change('AppointmentDialog', 'CustomAddressID', null));
      this.props.dispatch(change('AppointmentDialog', 'ServiceAddress', null));

      this.props.dispatch(change('AppointmentDialog', 'IsDirectService', null));
      this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromPayroll', false));
      this.props.dispatch(change('AppointmentDialog', 'IsExcludedFromMileage', false));
      this.props.dispatch(change('AppointmentDialog', 'IsRBTTracking', false));
      this.props.dispatch(change('AppointmentDialog', 'IsClientCheckedIn', false));
      this.props.dispatch(change('AppointmentDialog', 'ClinicalRoomId', null));

      this.props.dispatch(change('AppointmentDialog', 'SupervsieeStaffIds', null));
      this.props.dispatch(change('AppointmentDialog', 'ModeOfMeetingId', null));
      this.props.dispatch(change('AppointmentDialog', 'SupervisionTypeId', null));
      this.props.dispatch(change('AppointmentDialog', 'IsObservedWithclient', false));     
      this.props.dispatch(change('AppointmentDialog', 'Notes', null));
      this.props.dispatch(change('AppointmentDialog', 'IsMakeUpSession', false));      
            
    });  
    //Resting end

    if (selectedValue.value) {
      let isCallFromDailog = true;
      this.props.getStaffsAndPatientsList(selectedValue.value, isCallFromDailog);
      this.getDataForScheduler(selectedValue.value, this.props.selectorPatientId, this.props.selectorPatientInsuranceId);
    }
  }

  handleRecurrenceAppointments(e, actionType, appointmentObj) {
    let action = actionType.toLowerCase();
    let appointmentsArray = this.state.verifyRecurrenceAppointments;
    if (action === 'delete') {
      let index = appointmentsArray.indexOf(appointmentObj);
      if (index > -1) {
        appointmentsArray.splice(index, 1);
        // console.log(" delete ...", index, appointmentsArray)
        this.setState({ verifyRecurrenceAppointments: appointmentsArray });
      }
    } else if (action === 'edit') {
      let index = appointmentsArray.indexOf(appointmentObj);
      this.setState({
        openDateDialog: true,
        changeAppointmentIndex: index,
        recurrenceAppointmentStartTime: moment.utc(appointmentObj.startDateTime).format('YYYY-MM-DDTHH:mm:ss'),
        recurrenceAppointmentEndTime: moment.utc(appointmentObj.endDateTime).format('YYYY-MM-DDTHH:mm:ss'),
        // recurrenceAppointmentStartTime: new Date(moment.utc(appointmentObj.startDateTime)),
        // recurrenceAppointmentEndTime: new Date(moment.utc(appointmentObj.endDateTime)),
        changeAppointmentObj: appointmentObj,
      });
    } else if (action === 'change') {
      if (this.state.changeAppointmentIndex > -1) {
        appointmentsArray.splice(this.state.changeAppointmentIndex, 1, appointmentObj);
        // console.log(" add ...", this.state.changeAppointmentIndex, appointmentsArray)
        this.setState({
          openDateDialog: false,
          verifyRecurrenceAppointments: appointmentsArray,
        });
      }
    }
  }

  handleCloseDateDialog() {
    this.setState({ openDateDialog: false, changeAppointmentIndex: null, changeAppointmentObj: null });
  }

  onChangeHandler(event, data,input,selectedValue) {
    let patientId = this.state.schedulerPatientId || this.props.selectorPatientId;
    this.props.dispatch(change('AppointmentDialog', 'PatientID', null));
    if (data.length > 2) {
      let viewTeamClientsOnly = this.props.viewTeamClientsOnlyPermission;
      this.props.getPatientByName({ filter: 'searchKey', keyword: data, locationId: this.state.selectedLocationID, pageSize: '5', viewTeamClientsOnly});
    } else if (data === '') {
      this.setState({ value: '', searched_patients: [], allowMultipleStaff: true });
      this.getDataForScheduler(this.state.selectedLocationID, null);
      // if (this.props.master_data && this.props.master_data.appointmentType) {
      //   let appointmentTypes = this.props.master_data.appointmentType.filter((obj) => !obj.isBillAble);
      //   this.setState({ appointmentTypes: appointmentTypes });
      // }
    }
    this.checkIsValidAppointmentPatient(this.props.selectorStaffIds,patientId,this.props.selectorAppointmentTypeId);
  }

  handleRuleChange = (e) => {
    var rule = e.target.value;
    this.setState({
      rule: rule,
    });
  }
  handleIntervalChange = (e) => {
    var interval;
    if (e.target.value !== '') {
      interval = parseInt(e.target.value, 10);
    } else {
      interval = 0;
    }
    this.setState({
      interval: interval,
    });
  }
  handleValidationsChange = (validations) => {
    this.setState({
      validations: validations,
    });
  }

  /* api calls start ... */

  checkIsValidAppointment = (staffId, patientId, apptId = null) => {
    // check the appointment staffs availablity through api request ...
    let appointmentStaffs = null;
    if (staffId) {
      //let staffIds = this.state.allowMultipleStaff ? staffId : [staffId];
      let staffIds = [staffId];
      let staffIdsArray = [];
      appointmentStaffs = this.state.appointmentStaffs.map((Obj) => {
        return { StaffId: Obj.staffId, IsDeleted: true };
      });

      if(staffIds.toString().indexOf(',') !== -1){
        staffIdsArray = staffIds.toString().split(',');
      }
      else {
        staffIdsArray = staffIds;
      }
      
      if(appointmentStaffs && appointmentStaffs.length > 0) {
        staffIdsArray.forEach((staffId) => {
        
        // update case for appointment staffs ------
        let staff = appointmentStaffs.find((Obj) => Obj.StaffId === staffId && Obj.IsDeleted);
        if (staff) {
          let index = appointmentStaffs.indexOf(staff);
          appointmentStaffs[index] = { StaffId: parseInt(staff.StaffId), IsDeleted: false };
        } else {
          appointmentStaffs.push({ StaffId: parseInt(staffId), IsDeleted: false });
        }
      });
    } else {
      staffIdsArray.forEach((staffId) => {
        appointmentStaffs.push({ StaffId: parseInt(staffId), IsDeleted: false });
      });   
    }
    }
    let appointmentData = [{
      'PatientAppointmentId': this.state.appointmentId || null,
      'AppointmentTypeID': apptId || null,
      'AppointmentStaffs': appointmentStaffs,
      'PatientID': patientId || null,
      'LocationId': this.state.selectedLocationID || null,
      'StartDateTime': moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm')+':00',
      'EndDateTime': moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.endTime).format('HH:mm')+':00',
      'patientInsuranceId': this.props.selectorPatientInsuranceId || 0
    }];
    // console.log('Check is valid...', JSON.stringify(appointmentData));
    this.props.checkIsValidAppointment(appointmentData);
  }

  checkIsValidAppointmentPatient = (staffId, patientId, apptId = null) => {
    let appointmentStaffs = null;
    if (staffId) {
      //let staffIds = this.state.allowMultipleStaff ? staffId : [staffId];
      let staffIds = [staffId];
      let staffIdsArray = [];
      appointmentStaffs = this.state.appointmentStaffs.map((Obj) => {
        return { StaffId: Obj.staffId, IsDeleted: true };
      });

      if(staffIds.toString().indexOf(',') !== -1){
        staffIdsArray = staffIds.toString().split(',');
      }
      else {
        staffIdsArray = staffIds;
      }

      if(appointmentStaffs && appointmentStaffs.length > 0) {
        staffIdsArray.forEach((staffId) => {

        // update case for appointment staffs ------
        let staff = appointmentStaffs.find((Obj) => Obj.StaffId === staffId && Obj.IsDeleted);
        if (staff) {
          let index = appointmentStaffs.indexOf(staff);
          appointmentStaffs[index] = { StaffId: parseInt(staff.StaffId), IsDeleted: false };
        } else {
          appointmentStaffs.push({ StaffId: parseInt(staffId), IsDeleted: false });
        }
      });
    } else {
      staffIdsArray.forEach((staffId) => {
        appointmentStaffs.push({ StaffId: parseInt(staffId), IsDeleted: false });
      });   
    }
    }
    let appointmentData = [{
      'PatientAppointmentId': this.state.appointmentId || null,
      'AppointmentTypeID': apptId || null,
      'AppointmentStaffs': appointmentStaffs,
      'PatientID': patientId || null,
      'LocationId': this.state.selectedLocationID || null,
      'StartDateTime': moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm')+':00',
      'EndDateTime': moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.endTime).format('HH:mm')+':00',
      'patientInsuranceId': this.props.selectorPatientInsuranceId || 0
    }];
    // console.log('Check is valid...', JSON.stringify(appointmentData));
    this.props.checkIsValidAppointmentPatient(appointmentData);
  }


  checkAuthorizationDetails(appointmentTypeId, insuranceId = null, authorizationId = null) {
    let patientId = this.state.schedulerPatientId || this.props.selectorPatientId,
      isPatientAuthorization = (insuranceId && authorizationId);

    if (isCheckForPatientInsurance) {
      patientId = isPatientAuthorization ? patientId : null;
    }
    if (patientId) {
      let searchObj = {
        'appointmentId': this.state.appointmentId || null,
        'patientId': patientId,
        'appointmentTypeId': appointmentTypeId,
        'startDate': moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm:ss'),
        'endDate': moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.endTime).format('HH:mm:ss'),
        'isAdmin': (this.props.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission) ? true : false,
        'patientInsuranceId': isPatientAuthorization ? insuranceId : null,
        'authorizationId': isPatientAuthorization ? authorizationId : null,
      };
      // console.log('searchObj..', JSON.stringify(searchObj));
      if (searchObj.appointmentTypeId)
        this.props.getPatientAuthorizationDetails(searchObj);
    } else {
      this.setState({ isAppointmentAuthorized: true, authorizationMessage: '' });
    }
  }

  checkClinicalRoomAvailablity = (clinicalRoomId) => {    
    let searchObj = {
      'appointmentId': this.state.appointmentId || 0,
      // 'appointmentTypeId': apptId || null,
      // 'appointmentStaffId': appointmentStaffs[0].StaffId,
      // 'patientId': patientId || null,
       'locationId': this.state.selectedLocationID || null,
      'startDateTime': moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm:ss'),
      'endDateTime': moment(this.state.endTime).format('YYYY-MM-DD') + 'T' + moment(this.state.endTime).format('HH:mm:ss'),      
      'clinicalRoomId': clinicalRoomId || null,
    };
    // console.log('Check is valid...', searchObj);
    this.props.checkClinicalRoomAvailablity(searchObj);
    
  }


  getDataForScheduler(locationId, patientId, patientInsuranceId = null) {
    let startDateTime = moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm:ss');
    let endDateTime = moment(this.state.endTime).format('YYYY-MM-DD') + 'T' + moment(this.state.endTime).format('HH:mm:ss');
    if (isCheckForPatientInsurance) {
      patientId = patientInsuranceId ? patientId : null;
    }
    if (this.state.appointmentId) {
      this.props.getDataForScheduler(locationId, patientId, startDateTime, endDateTime, patientInsuranceId);
    }
    else
    {
      this.props.getDataForSchedulerForNewAppointment(locationId, patientId, startDateTime, endDateTime, patientInsuranceId);
    }

  }

  getPatientInsuranceList(patientId) {
    let startDateTime = moment(this.state.startDate).format('YYYY-MM-DD') + 'T' + moment(this.state.startTime).format('HH:mm:ss');
    if (patientId) {
      this.props.getPatientInsuranceById(patientId, 'PRIMARY', (this.state.appointmentId ? true : false),startDateTime);
    }
  }

  getPatientAuthorizationsList(patientInsuranceId, patientId) {
    let startDate = this.state.startDate ? moment(this.state.startDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    this.props.getPatientAuthorizationsList(patientId || null, patientInsuranceId || null, startDate);
  }

  /* api calls end ... */

  renderLoading() {
    return (
      <div>
        {this.props.loadingPatientDetails || this.props.loadingCheckAvailablity || this.props.loadingPatientAuthDetails || this.props.loadingPatientInsurance || this.props.loadingCreateAppointment || this.props.loadingRecurrenceAppointments ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit, loadingCheckAvailablity, loadingPatientAuthDetails, loadingPatientInsurance, isAppointmentInPendingStatus, isNotificationSent, isRecurrence, isAdminUpdateAfterRendered, isUpdateAfterClaimSubmitted } = this.props;
    const { schedulerPatientId, searched_patients, appointmentTypes, dropdownServiceLocations, isBillableAppointment } = this.state;
    let isLoading = loadingCheckAvailablity || loadingPatientAuthDetails || loadingPatientInsurance,
      isPendingAppointment = (isAppointmentInPendingStatus && !this.props.isRequestFromPatientPortal),
      submitLabel = this.state.verifyRecurrenceAppointments ? 'Continue' : isRecurrence && this.state.appointmentId ? this.props.batchParentAppointmentId > 0 && this.props.addMultipleStaffWhenCreatingNonBillableSession ? 'Edit Series for Individual Staff' : (!isBillableAppointment && !this.props.addMultipleStaffWhenCreatingNonBillableSession ? '' : 'Edit Series') : 'Save',
      submitBulkLabel = this.state.verifyRecurrenceAppointments && submitLabel !== 'Continue' ? 'Continue' : isRecurrence && !isAdminUpdateAfterRendered && this.state.appointmentId && this.props.batchParentAppointmentId > 0 && this.props.addMultipleStaffWhenCreatingNonBillableSession ? 'Edit Series for All Staff' : '',
      submitClick = this.state.verifyRecurrenceAppointments ? this.onRecurrenceSubmit.bind(this) : handleSubmit(this.onSubmitHandler.bind(this)),
      submitServiesForIndividualStaffClick = this.state.verifyRecurrenceAppointments ? this.onRecurrenceSubmit.bind(this) : handleSubmit(this.onSubmitServiesForIndividualStaffHandler.bind(this)),
      submitBulkClick = this.state.verifyRecurrenceAppointments ? this.onRecurrenceSubmit.bind(this) : handleSubmit(this.onSubmitBulkHandler.bind(this)),
      singleSubmitLabel = isRecurrence && this.state.appointmentId && !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted ? 'Edit Today\'s Session for Individual Staff' : 'Save',
      singleSubmitLabelForIndividualStaff = !isRecurrence && this.state.appointmentId && !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted ? 'Edit Today\'s Session for Individual Staff' : '',
      singleSubmitBulkLabel = isRecurrence && this.state.appointmentId && !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted && this.props.batchParentAppointmentId > 0 && this.props.addMultipleStaffWhenCreatingNonBillableSession ? 'Edit Today\'s Session for All Staff' : '',
      singleSubmitClick = handleSubmit(this.onSingleSubmitHandler.bind(this)),
      singleSubmitTodaysSessionForIndividualStaffClick = handleSubmit(this.onSingleSubmitTodaysSessionForIndividualStaffHandler.bind(this)),      
      singleSubmitBulkClick = handleSubmit(this.onSingleSubmitBulkHandler.bind(this));
    let submitButton = this.props.loading ?
      <CommonButton primary={true} className="loader_btn mr-15" disabled={true} label="Loading" /> :
      <CommonButton primary={true} className="mr-15" disabled={isLoading || isPendingAppointment} label={submitLabel} onTouchTap={submitLabel === 'Edit Series for Individual Staff' ? submitServiesForIndividualStaffClick : submitClick} />;      

      let submitBulkLabelButton = this.props.loading ?
      <CommonButton primary={true} className="loader_btn mr-15" disabled={true} label="Loading" /> :
      <CommonButton primary={true} className="mr-15" disabled={isLoading || isPendingAppointment} label={submitBulkLabel} onTouchTap={submitBulkClick} />;
    // const actions = [
    //   <CommonButton className="grey_btn mr-15" label="Cancel" onClick={this.handleClose} />,
    //   submitButton,
    // ];

     let singleSubmitButton = this.props.loading ? 
     <CommonButton primary={true} className="loader_btn mr-15 mt-10" disabled={true} label="Loading" /> :
     <CommonButton primary={true} className="mr-15 mt-10" disabled={isLoading || isPendingAppointment} label={singleSubmitLabel} onTouchTap={singleSubmitLabel === 'Save3' ? singleSubmitClick : singleSubmitTodaysSessionForIndividualStaffClick} />;

     let singleSubmitButtonForIndividualStaff = this.props.loading ? 
     <CommonButton primary={true} className="loader_btn mr-15 mt-10" disabled={true} label="Loading" /> :
     <CommonButton primary={true} className="mr-15 mt-10" disabled={isLoading || isPendingAppointment} label={singleSubmitLabelForIndividualStaff} onTouchTap={singleSubmitTodaysSessionForIndividualStaffClick} />;

     let singleSubmitBulkButton = this.props.loading ? 
     <CommonButton primary={true} className="loader_btn mr-15 mt-10" disabled={true} label="Loading" /> :
     <CommonButton primary={true} className="mr-15 mt-10" disabled={isLoading || isPendingAppointment} label={singleSubmitBulkLabel} onTouchTap={singleSubmitBulkClick} />;

     let actions = [];      
     
      {this.props.agencyName.toUpperCase() === POPPYSPROMISE ?    
        !isRecurrence ? 
          actions = [ 
            // <RaisedButton className={isNotificationSent ? "blue_btn mr-15 mt-10 reset-disable" : "blue_btn mr-15 mt-10"} disabled={isNotificationSent ? true : false} onTouchTap={(e) => this.handleChangeBatchRenderingProvider(e)} >Batch Change Rendering Provider</RaisedButton>,
            <CommonButton primary={true} className={isNotificationSent ? "blue_btn mr-15 mt-10 reset-disable" : "blue_btn mr-15 mt-10"} disabled={!isNotificationSent && this.state.appointmentId ? false : true } label="Send Notification" onClick={this.handleSendAppointmentNotification}/>,
            <CommonButton className="grey_btn mr-15 mt-10" label="Cancel" onClick={this.handleClose} />,
            !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted ? (!isBillableAppointment && !this.props.addMultipleStaffWhenCreatingNonBillableSession ? null : submitButton) : null,
            !this.state.verifyRecurrenceAppointments && (isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId ? singleSubmitButton : null,          
          ]
        :
          actions = [ 
            // <RaisedButton className={isNotificationSent ? "blue_btn mr-15 mt-10 reset-disable" : "blue_btn mr-15 mt-10"} disabled={isNotificationSent ? true : false} onTouchTap={(e) => this.handleChangeBatchRenderingProvider(e)} >Batch Change Rendering Provider</RaisedButton>,
            <CommonButton primary={true} className={isNotificationSent ? "blue_btn mr-15 mt-10 reset-disable" : "blue_btn mr-15 mt-10"} disabled={!isNotificationSent && this.state.appointmentId ? false : true } label="Send Notification" onClick={this.handleSendAppointmentNotification}/>,
            !this.state.verifyRecurrenceAppointments ? <CommonButton className="grey_btn mr-15 mt-10" label="Cancel" onClick={this.handleClose} /> : null,
            this.props.disableAppointmentEditing === false && !this.state.verifyRecurrenceAppointments && (isRecurrence || isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId  && submitBulkLabel !== '' ? submitBulkLabelButton : null,
            this.props.disableAppointmentEditing === false && this.props.editAppointmentTimeOnlyPermission == false  && !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted ? (!isBillableAppointment && !this.props.addMultipleStaffWhenCreatingNonBillableSession ? null : submitButton) : null,
            this.props.disableAppointmentEditing === false && !this.state.verifyRecurrenceAppointments && (isRecurrence || isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId && singleSubmitBulkLabel !== ''? singleSubmitBulkButton : null, 
            this.props.disableAppointmentEditing === false && !this.state.verifyRecurrenceAppointments && (isRecurrence || isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId ? singleSubmitButton : null,          
          ]
      :  
      !isRecurrence ? 
        actions = [ 
          <CommonButton className="grey_btn mr-15 mt-10" label="Cancel" onClick={this.handleClose} />,
          !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted ? submitButton : null,
          !this.state.verifyRecurrenceAppointments && (isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId ? singleSubmitButton : null,
          !isBillableAppointment && !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted && this.state.appointmentId ? singleSubmitButtonForIndividualStaff : null,
        ]
        :
        actions = [ 
          !this.state.verifyRecurrenceAppointments ? <CommonButton className="grey_btn mr-15 mt-10" label="Cancel" onClick={this.handleClose} /> : null,
          this.props.disableAppointmentEditing === false && !this.state.verifyRecurrenceAppointments && (isRecurrence || isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId  && submitBulkLabel !== '' ? submitBulkLabelButton : null,
          this.props.disableAppointmentEditing === false && this.props.editAppointmentTimeOnlyPermission == false  && !isAdminUpdateAfterRendered && !isUpdateAfterClaimSubmitted ? (!isBillableAppointment && !this.props.addMultipleStaffWhenCreatingNonBillableSession ? null : submitButton) : null,
          this.props.disableAppointmentEditing === false && !this.state.verifyRecurrenceAppointments && (isRecurrence || isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId && singleSubmitBulkLabel !== ''? singleSubmitBulkButton : null, 
          this.props.disableAppointmentEditing === false && !this.state.verifyRecurrenceAppointments && (isRecurrence || isAdminUpdateAfterRendered || isUpdateAfterClaimSubmitted) && this.state.appointmentId ? singleSubmitButton : null,          
        ]
    }
     let expDate = new Date(2120,9,11);
     if(this.props.appointmentData && this.props.appointmentData.maxCardIssueEndDate){
      expDate = this.props.appointmentData.maxCardIssueEndDate
     }

    return (
      <div>
        <Dialog
          className="custom_modal_new_appointment"
          title={this.state.appointmentId ? 'Edit Appointment' : 'Create Appointment'}
          modal={false}
          open={this.state.open && !this.props.loading}
          actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <ChangeAppointmentDateDialog
            open={this.state.openDateDialog}
            recurrenceAppointmentStartTime={this.state.recurrenceAppointmentStartTime}
            recurrenceAppointmentEndTime={this.state.recurrenceAppointmentEndTime}
            closeDateDialog={this.handleCloseDateDialog}
            onDateChange={this.onDateChange}
            handleRecurrenceAppointments={this.handleRecurrenceAppointments}
            changeAppointmentIndex={this.state.changeAppointmentIndex}
            appointmentObj={this.state.changeAppointmentObj} />

          {this.state.verifyRecurrenceAppointments ?
            (<RenderRecurrenceList
              recurrenceAppointments={this.state.verifyRecurrenceAppointments}
              handleRecurrenceAppointments={this.handleRecurrenceAppointments}
              isEditRecurrence={this.state.isEditRecurrence}              
              {...this.props} />)
            : (<RenderForm
              appointmentId={this.state.appointmentId}
              schedulerPatientId={this.state.schedulerPatientId}
              selectorPatientId={this.props.selectorPatientId}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              startTime={this.state.startTime}
              endTime={this.state.endTime}
              searched_patients={searched_patients}
              appointmentTypes={appointmentTypes} // patient appointment types
             // patientInsuranceList={this.props.patientInsuranceList}
             // patientAuthorizationsList={this.props.patientAuthorizationsList}
              dropdownServiceLocations={dropdownServiceLocations}
              selectedLocationID={this.state.selectedLocationID}
              allStaff={this.state.allStaff}
              isBillableAppointment={this.state.isBillableAppointment}
              isRequiredAuthorization={this.state.isRequiredAuthorization}
              //allowMultipleStaff={this.state.allowMultipleStaff}
              allowMultipleStaff={this.state.allowMultipleStaff}
              isClientRequired={this.state.isClientRequired}              
              value={this.props.isInActive ? '' : this.state.value}
              isAppointmentAuthorized={this.state.isAppointmentAuthorized}
              authorizationMessage={this.state.authorizationMessage}
              availabilityErrorMessage={this.state.availabilityErrorMessage}
              insuranceErrorMessage ={this.state.insuranceErrorMessage}
              availabilityRemaininAuthMessage={this.state.availabilityRemaininAuthMessage}
              edit_in_recurrence={this.state.edit_in_recurrence}
              IsRecurrence={this.state.IsRecurrence}
              rule={this.state.rule}
              interval={this.state.interval}
              validations={this.state.validations}
              RecurrencePattern={this.state.RecurrencePattern}
              IsExcludeFromMileage={this.state.IsExcludeFromMileage}
              IsDirectService={this.state.IsDirectService}
              isServiceAtCustomAddress={this.state.isServiceAtCustomAddress}
              customAddress={this.state.customAddress}              
              dropdownPatientLocationTypes={this.props.dropdownPatientLocationTypes}
              dropdownModeOfMeeting={this.props.dropdownModeOfMeeting}
              dropdownSupervisionType={this.props.dropdownSupervisionType}
              onChangeHandler={this.onChangeHandler}
              selectedOrganizationLocations={this.state.selectedOrganizationLocations}
              handleChangeAppointmentType={this.handleChangeAppointmentType}
              handleChangePatientInsurance={this.handleChangePatientInsurance}
              handleChangePatientAuthorization={this.handleChangePatientAuthorization}
              handleChangeStaff={this.handleChangeStaff}
              handleChangeSupervsieeStaff={this.handleChangeSupervsieeStaff}              
              handleChangeOrganizationLocation={this.handleChangeOrganizationLocation}
              handleClick={this.handleClick}
              handleLocationChange={this.handleLocationChange}              
              onDateChange={this.onDateChange}
              Notes={this.props.Notes}
              handleRecurrenceChecked={this.handleRecurrenceChecked}
              handleRuleChange={this.handleRuleChange}
              handleIntervalChange={this.handleIntervalChange}
              handleValidationsChange={this.handleValidationsChange}
              changeIsDirectService={this.changeIsDirectService}
              handleCheckExcludeFromMileage={this.handleCheckExcludeFromMileage}
              GetFullAddress={this.GetFullAddress}
              IsFullAddressEmpty={this.IsFullAddressEmpty}
              isValidAddress={this.state.isValidAddress}
              viewClientSchedulesPermission={this.props.viewClientSchedulesPermission}
              editAppointmentTimeOnlyPermission={this.props.editAppointmentTimeOnlyPermission}
              disableAppointmentEditing={this.props.disableAppointmentEditing}
              {...this.props}
              editAppointmentAfterClaimSubmission={
                this.props.editAppointmentAfterClaimSubmission || this.props.isUpdateAfterClaimSubmitted}
              patientInsuranceList={this.state.patientInsuranceList}
              patientAuthorizationsList={this.state.patientAuthorizationsList}
              // editAppointmentMileageOnlyAfterRenderPermission={
              //   this.props.editAppointmentMileageOnlyAfterRenderPermission || this.props.isUpdateAfterClaimSubmitted}
              IsExcludeFromPayroll={this.state.IsExcludeFromPayroll}
              handleCheckExcludeFromPayroll={this.handleCheckExcludeFromPayroll}
              showAddressTypeDuringAppointmentCreation={this.props.showAddressTypeDuringAppointmentCreation}
              payRateTypeId = {this.props.payRateTypeId}
              agencyName = {this.props.agencyName}
              clinicalRoomId = {this.props.clinicalRoomId}              
              handleChangeRoom = {this.handleChangeRoom}        
              clinicalRoomAvailablityMessage = {this.state.clinicalRoomAvailablityMessage}
              clinicalRoomAvailablityCode = {this.state.clinicalRoomAvailablityCode}
              IsClientCheckedIn={this.state.IsClientCheckedIn}
              handleCheckClientCheckedIn={this.handleCheckClientCheckedIn}
              IsApptTimeEditableAfterRender={this.state.IsApptTimeEditableAfterRender}
              handleCheckMakeUpSession={this.handleCheckMakeUpSession}
              claimId = {this.state.claimId}
              addMultipleStaffWhenCreatingNonBillableSession={this.props.addMultipleStaffWhenCreatingNonBillableSession}
              modifySessionTimeAfterClaimSubmission={this.props.modifySessionTimeAfterClaimSubmission}
              isUpdateAfterClaimSubmitted={this.props.isUpdateAfterClaimSubmitted}
              updateTimeAfterRenderingTheSessionMessage={this.state.UpdateTimeAfterRenderingTheSessionMessage}
              updateTimeAfterSubmissionTheSessionMessage={this.state.UpdateTimeAfterSubmissionTheSessionMessage}
              UpdateMessageAfterSubmission={this.state.UpdateMessageAfterSubmission}
              IsMakeUpSession={this.state.IsMakeUpSession}
              maxCardIssueEndDate={expDate}
              patientEncounterId = {this.props.appointmentData && this.props.appointmentData.patientEncounterId}
              settingType = {this.state.setting_type}
              handleUserChange={this.handleUserChange}
              modifyAfterRenderPermission ={this.props.modifyAfterRenderPermission}
              // AdminRole = {this.props.AdminRole}
            />)}
        </Dialog>
      </div>
    );
  }
}

const selector = formValueSelector('AppointmentDialog');
const mapStateToProps = (state, ownProps) => {
  // console.log('appointment data...', state.scheduling.appointment);
  // let currentUser = state.login.loginUserInfo;
  let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';

  let appointmentData = null;
  let StaffIDs;
  if (ownProps.slotDetails.id) {
    appointmentData = state.scheduling.appointment ? state.scheduling.appointment.data : null;
  }
  let selectedSingleLocationId = null,
    selectedSingleStaffId = null,
    selectedSinglePatientName = null,
    selectedSinglePatientId = null;

  let staffsByLocation = [];
  if (!ownProps.patient_id) {
    if (ownProps.selectedLocations && ownProps.selectedLocations.length === 1) {
      selectedSingleLocationId = ownProps.selectedLocations[0].id;
      // when single location is selected then fetch the staffs lists from the state.scheduling.staffsAndPatientsByLocation
      if (state.scheduling.staffsAndPatientsByLocation) {
        let allList = state.scheduling.staffsAndPatientsByLocation.data;
        staffsByLocation = allList.staff;
      }
    }
    if (ownProps.selectedPatients && ownProps.selectedPatients.length === 1) {
      selectedSinglePatientName = ownProps.singleSelectedPatientName;
      selectedSinglePatientId = ownProps.selectedPatients[0];
    }
    if (ownProps.selectedStaffs) {
      if (ownProps.selectedStaffs.length === 1)
        selectedSingleStaffId = ownProps.selectedStaffs[0];
      else
        selectedSingleStaffId = (ownProps.selectedStaffs || []).find((id) => id === ownProps.slotDetails.resourceId) || null;
    }
  }
  let isAdminUpdateAfterRendered = false, isUpdateAfterClaimSubmitted = false, isAppointmentInPendingStatus = false, isNotificationSent = false, isRecurrence = false, batchParentAppointmentId = 0;
  let initial = {
    // default initial values ...
    PatientID: selectedSinglePatientId,
    PatientName: selectedSinglePatientName,
    StaffIDs: selectedSingleStaffId,
    SelectedLocationID: selectedSingleLocationId,
    startDate: ownProps.slotDetails.start,
    startTime: ownProps.slotDetails.start,
    endDate: ownProps.slotDetails.end,
    endTime: ownProps.slotDetails.end,
  };
  // get apppointment details in Edit Appoitment ...
  if (appointmentData) {
    let staffIds = [],singleStaffId = [], supervsieeStaffIds = [];
    isRecurrence = appointmentData.isRecurrence || false;
    isNotificationSent = appointmentData.isNotificationSent || false;
    isAppointmentInPendingStatus = (appointmentData.statusName || '').toLowerCase() === 'pending' ? true : false;
    isAdminUpdateAfterRendered = (appointmentData.claimId && appointmentData.canEdit);
    isUpdateAfterClaimSubmitted = (appointmentData.claimId && !appointmentData.canEdit);
    staffIds = appointmentData.appointmentStaffs.map((staff) => {
      return staff.staffId;
    });
    singleStaffId = appointmentData.appointmentSingleStaff.map((staff) => {
      return staff.staffId;
    });
    batchParentAppointmentId = appointmentData.batchParentAppointmentId || 0;
    supervsieeStaffIds = appointmentData.appointmentSupervsieeStaffs.map((staff) => {
      return staff.supervsieeStaffId;
    });
    // let serviceLocationID = null,
    //   serviceAddress = null;
    // if (state.scheduling.patientDetails && state.scheduling.patientDetails.data) {
    //   // get the service address selected in update case ...
    //   let allList = state.scheduling.patientDetails.data;
    //   let selectedServiceAddressId = appointmentData.officeAddressID || appointmentData.patientAddressID,
    //     selectedCustomAddressId = appointmentData.customAddressID;
    //   if (selectedServiceAddressId || selectedCustomAddressId) {
    //     let locationObj = allList.PatientAddresses.find((obj) => (obj.id === selectedServiceAddressId) || ((obj.key || '').toLowerCase() === 'other'));
    //     if (locationObj) {
    //       serviceLocationID = locationObj.rowNo;
    //       serviceAddress = locationObj.fullAddress || '';
    //     }
    //   }
    // }
    // console.log("testing",(appointmentData.allowMultipleStaff || !appointmentData.patientID) && ownProps.addMultipleStaffWhenCreatingNonBillableSession ? staffIds : (initial.StaffIDs && initial.StaffIDs.length ? initial.StaffIDs: staffIds[0] ))
    if (
        (appointmentData.allowMultipleStaff || !appointmentData.patientID) &&
        ownProps.addMultipleStaffWhenCreatingNonBillableSession
      ) {
        StaffIDs = staffIds;
      } else if (initial.StaffIDs) {
        StaffIDs = initial.StaffIDs;
      } else if(appointmentData.isBillable){
        StaffIDs = singleStaffId[0] ;
      }else {
        StaffIDs = staffIds.length === 1 ? staffIds[0] : staffIds;
      }
    initial = {
      // StaffIDs: ((appointmentData.allowMultipleStaff || !appointmentData.patientID) && ownProps.addMultipleStaffWhenCreatingNonBillableSession  ? staffIds : initial.StaffIDs),// : staffIds[0],
      //StaffIDs: ((appointmentData.allowMultipleStaff || !appointmentData.patientID) && ownProps.addMultipleStaffWhenCreatingNonBillableSession ? staffIds : (initial.StaffIDs && initial.StaffIDs.length ? initial.StaffIDs: appointmentData.isBillable ? singleStaffId[0] :  staffIds )),
      StaffIDs: StaffIDs,
      SingleStaffId: singleStaffId,
      SupervsieeStaffIds: supervsieeStaffIds,
      Notes: appointmentData.notes,
      PatientID: appointmentData.patientID,
      PatientName: appointmentData.patientName || 'Non-Billable',
      AppointmentTypeID: ownProps.slotDetails.isValidInsurance ? appointmentData.appointmentTypeID:null,
      SelectedLocationID: appointmentData.serviceLocationID,
      IsExcludedFromMileage: appointmentData.isExcludedFromMileage,
      IsTelehealthAppointment: appointmentData.isTelehealthAppointment,
      Recurrence: appointmentData.isRecurrence,
      IsDirectService: appointmentData.isDirectService ? 1 : 0,
      ServiceAddress: appointmentData.address,
      // ServiceAddress: serviceAddress,
      // ServiceLocationID: serviceLocationID,
      CustomAddressID: appointmentData.customAddressID || null,
      Mileage: appointmentData.mileage,
      DriveTime: appointmentData.driveTime,
      PatientInsuranceID: ownProps.slotDetails.isValidInsurance ? appointmentData.patientInsuranceId: null,
      PatientAuthorizationID: appointmentData.authorizationId,
      IsRBTTracking: appointmentData.isRBTTracking,
      //SupervsieeStaffId: appointmentData.supervsieeStaffId,
      ModeOfMeetingId: appointmentData.modeOfMeetingId,
      SupervisionTypeId: appointmentData.supervisionTypeId,
      IsObservedWithclient: appointmentData.isObservedWithclient || false,
      startDate: ownProps.slotDetails.start,
      startTime: ownProps.slotDetails.start,
      endDate: ownProps.slotDetails.end,
      endTime: ownProps.slotDetails.end,
      IsExcludedFromPayroll: appointmentData.isExcludedFromPayroll,
      PayRateTypeId: appointmentData.payRateTypeId,
      ClinicalRoomId: appointmentData.clinicalRoomId,
      IsClientCheckedIn: appointmentData.isClientCheckedIn,
      IsMakeUpSession: appointmentData.isMakeUpSession,
      MakeUpSessionHours:appointmentData.makeUpSessionHours,
    };
  }  
  let editAppointmentAfterClaimSubmission = appointmentData && (appointmentData.statusName || '').toLowerCase() === 'rendered' ? ownProps.editAppointmentAfterClaimSubmission ? false : true : false;
  // console.log('editAppointmentAfterClaimSubmission..........',editAppointmentAfterClaimSubmission, !isAdminUpdateAfterRendered)
  return {
    // AdminRole : state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN',
    loading: state.scheduling.loading,
    loadingSearchPatients: state.scheduling.loadingSearchPatients,
    loadingPatientDetails: state.scheduling.loadingPatientDetails,
    loadingCheckAvailablity: state.scheduling.loadingCheckAvailablity,
    loadingPatientAuthDetails: state.scheduling.loadingPatientAuthDetails,
    loadingPatientInsurance: state.scheduling.loadingPatientInsurance,
    loadingCreateAppointment: state.scheduling.loadingCreateAppointment,
    loadingRecurrenceAppointments: state.scheduling.loadingRecurrenceAppointments,
    initialValues: initial,
    staffs: staffsByLocation,
    appointmentData: appointmentData,
    appointment_created: state.scheduling.appointment_created,
    verifyRecurrenceAppointments: state.scheduling.verifyRecurrenceAppointments,
    allPatients: state.scheduling.patients,
    appointment_deleted: state.scheduling.appointment_deleted,
    userLocationList: state.login.userLocationList,
    currentLocationId: state.login.currentLocationId,
    staffsAndPatientsBySingleLocation: state.scheduling.staffsAndPatientsBySingleLocation,
    patientDetails: state.scheduling.patientDetails,
    patientAuthorizationDetails: state.scheduling.patientAuthorizationDetails,
    checkValidAppointment: state.scheduling.checkValidAppointment,
    patientInsuranceList: state.scheduling.patientInsuranceList,
    patientInsuranceListByDOS: state.scheduling.patientInsuranceListByDOS,
    patientAuthorizationsList: state.scheduling.patientAuthorizationsList,
    Notes: selector(state, 'Notes'),
    selectorPatientId: selector(state, 'PatientID'),
    selectorAppointmentTypeId: selector(state, 'AppointmentTypeID'),
    selectorPatientInsuranceId: selector(state, 'PatientInsuranceID'),
    selectorPatientAuthorizationId: selector(state, 'PatientAuthorizationID'),
    selectorStaffIds: selector(state, 'StaffIDs'),
    selectorSupervsieeStaffIds: selector(state, 'SupervsieeStaffIds'), 
    selectorIsRBTTracking: selector(state, 'IsRBTTracking'),
    selectorClinicalRoomId: selector(state, 'ClinicalRoomId'),
    isAdminUpdateAfterRendered: isAdminUpdateAfterRendered ? true : false,
    //editAppointmentMileageOnlyAfterRenderPermission: ownProps.editAppointmentMileageOnlyAfterRenderPermission && isAdminUpdateAfterRendered,
    isUpdateAfterClaimSubmitted: isUpdateAfterClaimSubmitted ? true : false,
    isAppointmentInPendingStatus: isAppointmentInPendingStatus,
    editAppointmentAfterClaimSubmission: editAppointmentAfterClaimSubmission || (isAdminUpdateAfterRendered && !ownProps.modifyAfterRenderPermission),
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    isNotificationSent: isNotificationSent,
    isRecurrence: isRecurrence,
    clinicalRoomAvailablityDetails: state.scheduling.clinicalRoomAvailablityDetails,
    batchParentAppointmentId: batchParentAppointmentId,
    singleStaffId: initial.SingleStaffId ? initial.SingleStaffId : 0,
    ownStartDate: ownProps.slotDetails && ownProps.slotDetails.start ? ownProps.slotDetails.start : null,
    defaultSettingType:  state.scheduling.appTypeDefaultSetting && state.scheduling.appTypeDefaultSetting.data,
  };
};

AppointmentDialog = reduxForm({
  form: 'AppointmentDialog', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(AppointmentDialog);

export default connect(mapStateToProps, {
  checkIsValidAppointmentPatient,
  createAppointment,
  deleteAppointment,
  getAppointmentData,
  getMasterData,
  getPatientByName,
  getStaffsAndPatientsByLocation,
  checkIsValidAppointment,
  getDataForScheduler,
  getDataForSchedulerForNewAppointment,
  getPatientAuthorizationDetails,
  getPatientInsuranceById,
  getPatientAuthorizationsList,
  sendAppointmentNotification, deleteAppointmentDataFromReoccurrence,deleteAppointmentBulkDataFromReoccurrence, checkClinicalRoomAvailablity, getPatientInsuranceByPatientIdAndDOS,getAppointmentTypeDefaultSetting })(AppointmentDialog);



// WEBPACK FOOTER //
// ./src/modules/scheduling/appointmentWithAuthDialog_NewFeatures.js